export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /**
   * Leverages the internal Python implmeentation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
};

export enum AccountStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type ActivityAttendeeNoteType = {
  __typename?: 'ActivityAttendeeNoteType';
  activity: PublicActivityType;
  attendee: ChildType;
  author: SupplierAdminType;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  supplier: MarketplaceSupplierType;
  text: Scalars['String'];
};

export type ActivityBlockInput = {
  sessions?: Maybe<Array<Maybe<MarketplaceActivityCreateSessionInput>>>;
};

export type ActivityBlockType = {
  __typename?: 'ActivityBlockType';
  checksum?: Maybe<Scalars['String']>;
  coreEndTime: Scalars['String'];
  coreStartTime: Scalars['String'];
  id: Scalars['UUID'];
  maxDate?: Maybe<Scalars['Date']>;
  minDate?: Maybe<Scalars['Date']>;
  sessions: Array<ActivitySessionType>;
  spotsLeft?: Maybe<Scalars['Int']>;
  timesVary: Scalars['Boolean'];
  totalSpotsFilledRatio?: Maybe<Scalars['Float']>;
  weekdays?: Maybe<Array<Maybe<DayOfWeek>>>;
};

export type ActivityBookingActivityFilterType = {
  __typename?: 'ActivityBookingActivityFilterType';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export enum ActivityBookingAdditionalInformationEmailStatus {
  /** Delivered */
  Delivered = 'DELIVERED',
  /** Read */
  Read = 'READ',
  /** Undelivered */
  Undelivered = 'UNDELIVERED'
}

export enum ActivityBookingBookingType {
  /** Instant booking */
  Instant = 'INSTANT',
  /** Subscription */
  Subscription = 'SUBSCRIPTION'
}

export type ActivityBookingByDateRangeType = {
  __typename?: 'ActivityBookingByDateRangeType';
  activity: PublicActivityType;
  additionalInformationCaptured: Scalars['Boolean'];
  additionalInformationEmailCount: Scalars['Int'];
  additionalInformationEmailLastSentAt?: Maybe<Scalars['DateTime']>;
  additionalInformationEmailStatus?: Maybe<ActivityBookingAdditionalInformationEmailStatus>;
  additionalInformationEmailStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  bookingType?: Maybe<ActivityBookingBookingType>;
  createdAt: Scalars['DateTime'];
  /** Indicates from which mutation this booking inserted in our database. */
  creationType: ActivityBookingCreationType;
  discount?: Maybe<Scalars['Decimal']>;
  finalAmount?: Maybe<Scalars['Decimal']>;
  guardian?: Maybe<NurseryGuardianType>;
  guest?: Maybe<GuestType>;
  id: Scalars['UUID'];
  isRefundable?: Maybe<Scalars['Boolean']>;
  isRefunded?: Maybe<Scalars['Boolean']>;
  numberOfTickets?: Maybe<Scalars['Int']>;
  originalAmount?: Maybe<Scalars['Decimal']>;
  payment?: Maybe<PaymentType>;
  promotion?: Maybe<PromotionType>;
  status: ActivityBookingStatus;
  supplierMarketingOptIn?: Maybe<Scalars['Boolean']>;
  tickets?: Maybe<Array<Maybe<ActivityBookingTicketType>>>;
};

export enum ActivityBookingCreationType {
  /** Free */
  Free = 'FREE',
  /** Moved */
  Moved = 'MOVED',
  /** Standard */
  Standard = 'STANDARD',
  /** Unpaid */
  Unpaid = 'UNPAID'
}

export type ActivityBookingFiltersType = {
  __typename?: 'ActivityBookingFiltersType';
  activities?: Maybe<Array<Maybe<ActivityBookingActivityFilterType>>>;
  times?: Maybe<Array<Maybe<ActivityBookingTimesFilterType>>>;
  venues?: Maybe<Array<Maybe<ActivityBookingVenueFilterType>>>;
  weeks?: Maybe<Array<Maybe<ActivityBookingWeekFilterType>>>;
};

export type ActivityBookingInfoType = {
  __typename?: 'ActivityBookingInfoType';
  description?: Maybe<Scalars['String']>;
  totalBookings?: Maybe<Scalars['Int']>;
  totalCapacity?: Maybe<Scalars['Int']>;
};

export enum ActivityBookingInvoiceEnum {
  Failed = 'FAILED',
  Pendind = 'PENDIND',
  Succeeded = 'SUCCEEDED'
}

export enum ActivityBookingInvoiceStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Failed */
  Failed = 'FAILED',
  /** Paid */
  Paid = 'PAID',
  /** Pending */
  Pending = 'PENDING',
  /** Transferred */
  Transferred = 'TRANSFERRED'
}

export type ActivityBookingSchemaType = {
  __typename?: 'ActivityBookingSchemaType';
  activity: PublicActivityType;
  basket?: Maybe<BasketType>;
  bookedTickets?: Maybe<Array<Maybe<ActivityBookingTicketType>>>;
  bookingType?: Maybe<ActivityBookingBookingType>;
  checkoutSessionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** Indicates from which mutation this booking inserted in our database. */
  creationType: ActivityBookingCreationType;
  discount?: Maybe<Scalars['Int']>;
  finalAmount?: Maybe<Scalars['Int']>;
  guardian?: Maybe<NurseryGuardianType>;
  guest?: Maybe<GuestType>;
  id: Scalars['UUID'];
  isManuallyAdded: Scalars['Boolean'];
  isRefundable?: Maybe<Scalars['Boolean']>;
  numberOfBookedTickets?: Maybe<Scalars['Int']>;
  originalAmount?: Maybe<Scalars['Int']>;
  payment?: Maybe<PaymentType>;
  promotion?: Maybe<PromotionType>;
  /** Remaining refund amount allowance */
  refundAllowance?: Maybe<Scalars['Int']>;
  refunds?: Maybe<Array<Maybe<RefundType>>>;
  /** Total booking refunds amount to date */
  refundsAmount?: Maybe<Scalars['Int']>;
  status: ActivityBookingStatus;
  /** Stripe Subscription.current_period_end */
  subscriptionNextPayment?: Maybe<Scalars['DateTime']>;
  subscriptionOption?: Maybe<BasketTicketSubscriptionOptionType>;
};

export enum ActivityBookingStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Moved */
  Moved = 'MOVED'
}

export type ActivityBookingTicketAddonType = {
  __typename?: 'ActivityBookingTicketAddonType';
  addonId: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export enum ActivityBookingTicketCancellationReason {
  /** Illness */
  Illness = 'ILLNESS',
  /** No longer needed */
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  /** Other */
  Other = 'OTHER'
}

export type ActivityBookingTicketSessionAddonType = {
  __typename?: 'ActivityBookingTicketSessionAddonType';
  addonId: Scalars['UUID'];
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  price: Scalars['Int'];
  status?: Maybe<Scalars['String']>;
};

export enum ActivityBookingTicketSessionCancellationReason {
  /** Customer requested */
  CustomerRequested = 'CUSTOMER_REQUESTED',
  /** Full activity cancelled */
  FullActivityCancelled = 'FULL_ACTIVITY_CANCELLED',
  /** Other */
  Other = 'OTHER',
  /** Session cancelled */
  SessionCancelled = 'SESSION_CANCELLED'
}

export enum ActivityBookingTicketSessionIsManuallyAddedBy {
  /** Supplier Moved */
  SupplierMoved = 'SUPPLIER_MOVED',
  /** Supplier Unpaid */
  SupplierUnpaid = 'SUPPLIER_UNPAID'
}

export enum ActivityBookingTicketSessionStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Moved */
  Moved = 'MOVED',
  /** Pending */
  Pending = 'PENDING'
}

export type ActivityBookingTicketSessionType = {
  __typename?: 'ActivityBookingTicketSessionType';
  attendance?: Maybe<Scalars['Boolean']>;
  bookingAddons?: Maybe<Array<Maybe<ActivityBookingTicketAddonType>>>;
  bookingTicket?: Maybe<ActivityBookingTicketType>;
  cancellationDetails?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<ActivityBookingTicketSessionCancellationReason>;
  checkInSupplierAdmin?: Maybe<SupplierAdminType>;
  checkInTime?: Maybe<Scalars['Time']>;
  checkOutSupplierAdmin?: Maybe<SupplierAdminType>;
  checkOutTime?: Maybe<Scalars['Time']>;
  child?: Maybe<ChildType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  isFreeTrialSession?: Maybe<Scalars['Boolean']>;
  isManuallyAddedBy?: Maybe<ActivityBookingTicketSessionIsManuallyAddedBy>;
  isPaidTrialSession?: Maybe<Scalars['Boolean']>;
  movedFrom?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<Maybe<ActivityAttendeeNoteType>>>;
  questionAnswers?: Maybe<Array<Maybe<MatchedQuestionAnswerType>>>;
  sessionAddons?: Maybe<Array<Maybe<ActivityBookingTicketSessionAddonType>>>;
  sessionEnd?: Maybe<Scalars['DateTime']>;
  /** The ordinal number of this session of the ticket booking */
  sessionNumber: Scalars['Int'];
  sessionStart?: Maybe<Scalars['DateTime']>;
  status: ActivityBookingTicketSessionStatus;
  /** The total number of sessions of the ticket booking */
  totalSessions: Scalars['Int'];
};

export type ActivityBookingTicketSessionsResultType = {
  __typename?: 'ActivityBookingTicketSessionsResultType';
  filters?: Maybe<ActivityBookingFiltersType>;
  sessions?: Maybe<Array<Maybe<ActivityBookingTicketSessionType>>>;
  total: Scalars['Int'];
};

export enum ActivityBookingTicketStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Moved */
  Moved = 'MOVED'
}

export type ActivityBookingTicketType = {
  __typename?: 'ActivityBookingTicketType';
  addonsByAttendee?: Maybe<Array<Maybe<AddonsByAttendeeType>>>;
  attendees: Array<ChildType>;
  booking: ActivityBookingByDateRangeType;
  createdAt: Scalars['DateTime'];
  firstSessionDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  lastSessionDate?: Maybe<Scalars['DateTime']>;
  numberOfSessions?: Maybe<Scalars['Int']>;
  schedule?: Maybe<ActivityScheduleType>;
  sessions?: Maybe<Array<Maybe<ActivityBookingTicketSessionType>>>;
  status: ActivityBookingTicketStatus;
  subscriptionDayOfWeek?: Maybe<Scalars['String']>;
  subscriptionEndTime?: Maybe<Scalars['String']>;
  subscriptionOffDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  subscriptionStartTime?: Maybe<Scalars['String']>;
  subscriptionTrialEnd?: Maybe<Scalars['DateTime']>;
  subscriptionTrialSelected?: Maybe<Scalars['Boolean']>;
  ticket?: Maybe<TicketType>;
  ticketCapacityAtBooking?: Maybe<Scalars['Int']>;
  ticketNameAtBooking?: Maybe<Scalars['String']>;
  ticketPriceAtBooking?: Maybe<Scalars['Int']>;
};

export type ActivityBookingTimesFilterType = {
  __typename?: 'ActivityBookingTimesFilterType';
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum ActivityBookingType {
  /** Enquiry */
  Enquiry = 'ENQUIRY',
  /** Instant booking */
  Instant = 'INSTANT',
  /** Subscription */
  Subscription = 'SUBSCRIPTION'
}

export type ActivityBookingVenueFilterType = {
  __typename?: 'ActivityBookingVenueFilterType';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ActivityBookingWeekFilterType = {
  __typename?: 'ActivityBookingWeekFilterType';
  end: Scalars['DateTime'];
  name: Scalars['String'];
  start: Scalars['DateTime'];
};

/** Summary of activity bookings for a specific supplier. */
export type ActivityBookingsBySupplierSummaryType = {
  __typename?: 'ActivityBookingsBySupplierSummaryType';
  supplierId?: Maybe<Scalars['UUID']>;
  /** Total number of confirmed marketplace activity bookings for all time. */
  totalConfirmedBookingsAllTime?: Maybe<Scalars['Int']>;
  /** Total number of confirmed marketplace activity bookings made this month. */
  totalConfirmedBookingsThisMonth?: Maybe<Scalars['Int']>;
  /** Total number of available spots on upcoming sessions. */
  totalSpotsLeftToFill?: Maybe<Scalars['Int']>;
};

/**
 * The object contains necessary information for displaying activity
 * in search results or the supplier page
 */
export type ActivityCard = {
  __typename?: 'ActivityCard';
  activityType: ActivityTypeEnum;
  additionalImageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  ageRange: Scalars['String'];
  anySpotsLeft: Scalars['Boolean'];
  bookingType: BookingTypesEnum;
  callToAction?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  dateRange?: Maybe<Scalars['String']>;
  distanceFull?: Maybe<Scalars['Float']>;
  distanceInMiles?: Maybe<Scalars['Float']>;
  eligibleChildren?: Maybe<Array<Maybe<ChildType>>>;
  email?: Maybe<Scalars['String']>;
  enquiryBookingUrl?: Maybe<Scalars['String']>;
  expressEnquiry?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isInPast: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  latitude?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nextSessionDate?: Maybe<Scalars['Date']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  priceRange?: Maybe<Scalars['String']>;
  reviewsEnabled?: Maybe<Scalars['Boolean']>;
  seoPageDescription: Scalars['String'];
  seoPageTitle: Scalars['String'];
  shortLocation?: Maybe<Scalars['String']>;
  showEmail?: Maybe<Scalars['Boolean']>;
  showEnquiryBookingUrl?: Maybe<Scalars['Boolean']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']>;
  slug: Scalars['String'];
  socialProof?: Maybe<SocialProof>;
  supplierId: Scalars['UUID'];
  supplierName: Scalars['String'];
  times: Scalars['String'];
  weekdays?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ActivityCreateMutation = {
  __typename?: 'ActivityCreateMutation';
  activity?: Maybe<SupplierMarketplaceActivityType>;
};

export enum ActivityDayOfWeekFilterEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type ActivityDeleteMutation = {
  __typename?: 'ActivityDeleteMutation';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type ActivityDetailsForMoveType = {
  __typename?: 'ActivityDetailsForMoveType';
  activity?: Maybe<PublicActivityType>;
  blockBookings?: Maybe<Array<Maybe<ProductType>>>;
  dateRange?: Maybe<Scalars['String']>;
  singleSessions?: Maybe<Array<Maybe<ProductsByDate>>>;
};

export type ActivityDetailsType = {
  __typename?: 'ActivityDetailsType';
  activity?: Maybe<PublicActivityType>;
  anySpotsLeft: Scalars['Boolean'];
  blockBookings?: Maybe<Array<Maybe<ProductType>>>;
  dateRange?: Maybe<Scalars['String']>;
  eligibleChildren?: Maybe<Array<Maybe<ChildType>>>;
  lastBookingTime?: Maybe<Scalars['DateTime']>;
  singleSessions?: Maybe<Array<Maybe<ProductsByDate>>>;
  tickets?: Maybe<ActivityTicketType>;
  totalActivityBookings: Scalars['Int'];
  weekdays?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ActivityFiltersType = {
  __typename?: 'ActivityFiltersType';
  activities?: Maybe<Array<Maybe<ActivityBookingActivityFilterType>>>;
  venues?: Maybe<Array<Maybe<ActivityBookingVenueFilterType>>>;
};

export type ActivityOffDayType = {
  __typename?: 'ActivityOffDayType';
  date: Scalars['String'];
  id: Scalars['UUID'];
};

/** Input for publishing/unpublishing an activity */
export type ActivityPublishInput = {
  activityId: Scalars['UUID'];
  desiredStatus: StatusEnum;
};

export type ActivityPublishMutation = {
  __typename?: 'ActivityPublishMutation';
  activity?: Maybe<SupplierMarketplaceActivityType>;
};

export type ActivityRegisterSessionType = {
  __typename?: 'ActivityRegisterSessionType';
  activity?: Maybe<SupplierMarketplaceActivityType>;
  block?: Maybe<ActivityBlockType>;
  bookingCount: Scalars['Int'];
  capacity: Scalars['Int'];
  date: Scalars['Date'];
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  schedule?: Maybe<ActivityScheduleType>;
  sessionBookings?: Maybe<Array<Maybe<ActivityBookingTicketSessionType>>>;
  spotsLeft?: Maybe<Scalars['Int']>;
  startTime?: Maybe<Scalars['String']>;
  totalRegistered?: Maybe<Scalars['Int']>;
};

export type ActivityScheduleType = {
  __typename?: 'ActivityScheduleType';
  activeSubs?: Maybe<Scalars['Int']>;
  capacity: Scalars['Int'];
  dayOfTheWeek: DayOfWeek;
  endTime: Scalars['String'];
  id: Scalars['UUID'];
  nextSessionDate: Scalars['Date'];
  spotsLeft?: Maybe<Scalars['Int']>;
  startTime: Scalars['String'];
};

export type ActivitySearchResult = {
  __typename?: 'ActivitySearchResult';
  items?: Maybe<Array<Maybe<ActivityCard>>>;
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export enum ActivitySessionDayOfTheWeek {
  /** Monday */
  A_1 = 'A_1',
  /** Tuesday */
  A_2 = 'A_2',
  /** Wednesday */
  A_3 = 'A_3',
  /** Thursday */
  A_4 = 'A_4',
  /** Friday */
  A_5 = 'A_5',
  /** Saturday */
  A_6 = 'A_6',
  /** Sunday */
  A_7 = 'A_7'
}

export type ActivitySessionType = {
  __typename?: 'ActivitySessionType';
  activity: PublicActivityType;
  addons: Array<AddonType>;
  bookingCount: Scalars['Int'];
  capacity: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  date: Scalars['Date'];
  /** The ISO day of the week this session takes place (Monday=1, Sunday=7). */
  dayOfTheWeek?: Maybe<ActivitySessionDayOfTheWeek>;
  endTime: Scalars['String'];
  id: Scalars['UUID'];
  spotsLeft?: Maybe<Scalars['Int']>;
  startTime: Scalars['String'];
  time: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum ActivityStatus {
  /** Draft */
  Draft = 'DRAFT',
  /** Published */
  Published = 'PUBLISHED',
  /** Unpublished */
  Unpublished = 'UNPUBLISHED'
}

export enum ActivitySubscriptionBillingFrequency {
  /** Day */
  Day = 'DAY',
  /** Month */
  Month = 'MONTH',
  /** Week */
  Week = 'WEEK',
  /** Year */
  Year = 'YEAR'
}

export enum ActivitySubscriptionTrialType {
  /** Free trial */
  FreeTrial = 'FREE_TRIAL',
  /** No trial */
  NoTrial = 'NO_TRIAL',
  /** Paid trial */
  PaidTrial = 'PAID_TRIAL'
}

/** Input for an activity ticket */
export type ActivityTicketInput = {
  allowBookingsAfterFirstSession?: Maybe<Scalars['Boolean']>;
  availabilityEndDate?: Maybe<Scalars['Date']>;
  availabilityStartDate?: Maybe<Scalars['Date']>;
  capacity: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  price: Scalars['Int'];
  pricingPolicy?: Maybe<PricingPolicy>;
};

export type ActivityTicketType = {
  __typename?: 'ActivityTicketType';
  block?: Maybe<Array<Maybe<TicketType>>>;
  individual?: Maybe<Array<Maybe<TicketType>>>;
  subscription?: Maybe<Array<Maybe<TicketType>>>;
};

/** Input for activity tickets */
export type ActivityTicketsInput = {
  block?: Maybe<Array<Maybe<ActivityTicketInput>>>;
  individual?: Maybe<Array<Maybe<ActivityTicketInput>>>;
  subscription?: Maybe<Array<Maybe<ActivityTicketInput>>>;
};

export enum ActivityTimeEnum {
  Am = 'AM',
  Pm = 'PM'
}

export type ActivityToggleRegisterCheckinCheckOutModeMutation = {
  __typename?: 'ActivityToggleRegisterCheckinCheckOutModeMutation';
  activity?: Maybe<SupplierMarketplaceActivityType>;
};

/** Input for toggling activity's register check-in/check-out mode */
export type ActivityToggleRegisterCheckinCheckoutModeInput = {
  activityId: Scalars['UUID'];
  enableRegisterCheckinCheckoutMode: Scalars['Boolean'];
};

export type ActivityTransactionActivityFilterType = {
  __typename?: 'ActivityTransactionActivityFilterType';
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type ActivityTransactionFiltersAndTotalsType = {
  __typename?: 'ActivityTransactionFiltersAndTotalsType';
  activities?: Maybe<Array<Maybe<ActivityTransactionActivityFilterType>>>;
  datetimeEnd: Scalars['DateTime'];
  datetimeStart?: Maybe<Scalars['DateTime']>;
  supplierPebbleUse: Scalars['String'];
  totalClicksToBook: Scalars['Int'];
  totalPending: Scalars['Float'];
  totalPotentialRevenue: Scalars['Float'];
  totalSucceededLast30Days: Scalars['Float'];
};

export enum ActivityTypeEnum {
  Block = 'BLOCK',
  Enquiry = 'ENQUIRY',
  OneOff = 'ONE_OFF',
  OneOffAndBlock = 'ONE_OFF_AND_BLOCK',
  Subscription = 'SUBSCRIPTION'
}

export type ActivityUpdateMutation = {
  __typename?: 'ActivityUpdateMutation';
  activity?: Maybe<SupplierMarketplaceActivityType>;
};

export type AdditionalInfoInputType = {
  activityBooking: Scalars['UUID'];
  questionAnswers?: Maybe<Array<Maybe<QuestionAnswerInputType>>>;
  supplierMarketingConsentGiven?: Maybe<Scalars['Boolean']>;
};

export type AdditionalInfoType = {
  __typename?: 'AdditionalInfoType';
  activityAddress?: Maybe<Scalars['String']>;
  activityBookingId: Scalars['UUID'];
  activityName?: Maybe<Scalars['String']>;
  additionalInformationCaptured?: Maybe<Scalars['Boolean']>;
  attendees?: Maybe<Array<Maybe<ChildAdditionalInfoType>>>;
  questionAnswers?: Maybe<Array<Maybe<QuestionAnswerType>>>;
  supplierMarketingConsentGiven?: Maybe<Scalars['Boolean']>;
  supplierName?: Maybe<Scalars['String']>;
};

export enum AddonAddonType {
  /** Per Booking */
  BookingLevel = 'BOOKING_LEVEL',
  /** Per Session */
  SessionLevel = 'SESSION_LEVEL'
}

export type AddonInput = {
  addonType?: Maybe<AddonTypes>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  name: Scalars['String'];
  /** Addon price in pence */
  price: Scalars['Int'];
};

export type AddonOptionType = {
  __typename?: 'AddonOptionType';
  availableSessions?: Maybe<Array<Maybe<BasketActivitySessionType>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type AddonType = {
  __typename?: 'AddonType';
  /** Select between Session and Booking level */
  addonType: AddonAddonType;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  name: Scalars['String'];
  price: Scalars['Int'];
};

export enum AddonTypes {
  BookingLevel = 'BOOKING_LEVEL',
  SessionLevel = 'SESSION_LEVEL'
}

export type AddonsByAttendeeType = {
  __typename?: 'AddonsByAttendeeType';
  attendee?: Maybe<ChildType>;
  bookingAddons?: Maybe<Array<Maybe<CustomAddonType>>>;
  sessionAddons?: Maybe<Array<Maybe<CustomAddonType>>>;
};

export enum AdminAccessName {
  /** Activity Registers */
  ActivityRegisters = 'ACTIVITY_REGISTERS'
}

export type AdminAccessType = {
  __typename?: 'AdminAccessType';
  id: Scalars['UUID'];
  /** A representative name for the new admin access option */
  name: AdminAccessName;
  niceName?: Maybe<Scalars['String']>;
};

export type AllBookingsForGuardianType = {
  __typename?: 'AllBookingsForGuardianType';
  bookingId?: Maybe<Scalars['UUID']>;
  bookingType?: Maybe<Scalars['String']>;
  child?: Maybe<ChildType>;
  customSessionType?: Maybe<CustomSessionTypeModelType>;
  date?: Maybe<Scalars['Date']>;
  endTime?: Maybe<Scalars['Time']>;
  marketplaceActivity?: Maybe<MarketplaceActivityType>;
  sessionId?: Maybe<Scalars['UUID']>;
  sessionType?: Maybe<SessionType>;
  showCustomSessionTimes?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['Time']>;
  status?: Maybe<Status>;
  subscriptionDayOfWeek?: Maybe<Scalars['String']>;
  subscriptionEndTime?: Maybe<Scalars['String']>;
  subscriptionStartTime?: Maybe<Scalars['String']>;
};

export type AnonymisedActivityBookingSchemaType = {
  __typename?: 'AnonymisedActivityBookingSchemaType';
  activity: PublicActivityType;
  basketId?: Maybe<Scalars['UUID']>;
  bookedTickets?: Maybe<Array<Maybe<AnonymisedActivityBookingTicketType>>>;
  bookingType?: Maybe<ActivityBookingBookingType>;
  checkoutSessionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  discount?: Maybe<Scalars['Decimal']>;
  finalAmount?: Maybe<Scalars['Decimal']>;
  guardianId?: Maybe<Scalars['UUID']>;
  guestId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  numberOfBookedTickets?: Maybe<Scalars['Int']>;
  originalAmount?: Maybe<Scalars['Decimal']>;
  promotion?: Maybe<PromotionType>;
  status: ActivityBookingStatus;
  /** Stripe Subscription.current_period_end */
  subscriptionNextPayment?: Maybe<Scalars['DateTime']>;
  subscriptionOption?: Maybe<BasketTicketSubscriptionOptionType>;
};

export type AnonymisedActivityBookingTicketSessionType = {
  __typename?: 'AnonymisedActivityBookingTicketSessionType';
  addons?: Maybe<Array<Maybe<ActivityBookingTicketSessionAddonType>>>;
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  isFreeTrialSession?: Maybe<Scalars['Boolean']>;
  isPaidTrialSession?: Maybe<Scalars['Boolean']>;
  sessionEnd?: Maybe<Scalars['DateTime']>;
  /** The ordinal number of this session of the ticket booking */
  sessionNumber: Scalars['Int'];
  sessionStart?: Maybe<Scalars['DateTime']>;
  status: ActivityBookingTicketSessionStatus;
  /** The total number of sessions of the ticket booking */
  totalSessions: Scalars['Int'];
};

export type AnonymisedActivityBookingTicketType = {
  __typename?: 'AnonymisedActivityBookingTicketType';
  attendeeIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  bookingAddons?: Maybe<Array<Maybe<ActivityBookingTicketAddonType>>>;
  bookingId: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  firstSession?: Maybe<SubscriptionBookingTicketSessionType>;
  firstSessionDate?: Maybe<Scalars['DateTime']>;
  /** Subscription field only */
  firstSessionToBe?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  lastSessionDate?: Maybe<Scalars['DateTime']>;
  numberOfSessions?: Maybe<Scalars['Int']>;
  schedule?: Maybe<ActivityScheduleType>;
  sessions?: Maybe<Array<Maybe<AnonymisedActivityBookingTicketSessionType>>>;
  status: ActivityBookingTicketStatus;
  subscriptionDayOfWeek?: Maybe<Scalars['String']>;
  subscriptionEndTime?: Maybe<Scalars['String']>;
  subscriptionOffDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  subscriptionStartTime?: Maybe<Scalars['String']>;
  subscriptionTrialEnd?: Maybe<Scalars['DateTime']>;
  subscriptionTrialPrice?: Maybe<Scalars['Int']>;
  subscriptionTrialSelected?: Maybe<Scalars['Boolean']>;
  subscriptionTrialSessionCount?: Maybe<Scalars['Int']>;
  ticket?: Maybe<TicketType>;
  ticketCapacityAtBooking?: Maybe<Scalars['Int']>;
  ticketNameAtBooking?: Maybe<Scalars['String']>;
  ticketPriceAtBooking?: Maybe<Scalars['Int']>;
};

export enum AttendanceActionEnum {
  CheckIn = 'CHECK_IN',
  CheckOut = 'CHECK_OUT',
  MarkAbsent = 'MARK_ABSENT',
  MarkAttended = 'MARK_ATTENDED',
  MarkUnknown = 'MARK_UNKNOWN',
  UnCheckOut = 'UN_CHECK_OUT'
}

export type AttendeeAddonInputType = {
  attendeeId: Scalars['UUID'];
  perBooking?: Maybe<Array<Maybe<PerBookingAddonInputType>>>;
  perSession?: Maybe<Array<Maybe<PerSessionAddonInputType>>>;
};

export type AttendeeAddonList = {
  __typename?: 'AttendeeAddonList';
  attendee?: Maybe<ChildType>;
  perBooking?: Maybe<Array<Maybe<PerBookingAddonList>>>;
  perSession?: Maybe<Array<Maybe<PerSessionAddonList>>>;
};

export type AttendeeAnswerInputType = {
  answer: Scalars['String'];
  attendeeId: Scalars['UUID'];
};

export type AttendeeAnswerType = {
  __typename?: 'AttendeeAnswerType';
  answer?: Maybe<Scalars['String']>;
  attendeeId: Scalars['UUID'];
  previousAnswer?: Maybe<Scalars['String']>;
};

export type AttendeeInputType = {
  birthDate?: Maybe<Scalars['Date']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isAdult?: Maybe<Scalars['Boolean']>;
};

export type AttendeeSessionMovedType = {
  __typename?: 'AttendeeSessionMovedType';
  additionalInformationRequested?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AttendeeTimeItemInputType = {
  endTime: Scalars['Time'];
  startTime: Scalars['Time'];
};

export type AttendeeType = {
  __typename?: 'AttendeeType';
  email: Scalars['String'];
};

export type AvailabilitiesUpdateMutation = {
  __typename?: 'AvailabilitiesUpdateMutation';
  availabilities?: Maybe<Array<Maybe<NurseryAvailabilityMultiRoomSingleDateType>>>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Availability for multiple rooms for multiple dates */
export type AvailabilityAndPricesMultiRoomSingleDateType = {
  __typename?: 'AvailabilityAndPricesMultiRoomSingleDateType';
  nurseryRooms?: Maybe<Array<Maybe<NurseryRoomWithAvailabilityAndPriceForDateType>>>;
};

/** Input for creating or updating an availability */
export type AvailabilityDateType = {
  date: Scalars['Date'];
  newAmSpots?: Maybe<Scalars['Int']>;
  newPmSpots?: Maybe<Scalars['Int']>;
};

/** Summary of availability for a specific nursery  */
export type AvailabilityForNurseryAdminSummaryType = {
  __typename?: 'AvailabilityForNurseryAdminSummaryType';
  /** Last updated time for Availability from tomorrow onwards. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** A total of any remaining spots from tomorrow onwards. */
  totalRemainingAvailability?: Maybe<Scalars['Int']>;
};

export type AvailabilityForNurseryType = {
  __typename?: 'AvailabilityForNurseryType';
  availability?: Maybe<Array<Maybe<NurseryAvailabilityMultiRoomSingleDateType>>>;
  nursery?: Maybe<NurserySummaryType>;
};

/** Availability for multiple rooms for multiple dates */
export type AvailabilityMultiRoomMultiDateType = {
  __typename?: 'AvailabilityMultiRoomMultiDateType';
  dates?: Maybe<Array<Maybe<AvailabilityMultiRoomSingleDateType>>>;
  earliestBookingRequestSession?: Maybe<Scalars['DateTime']>;
  earliestInstantBookingSession?: Maybe<Scalars['DateTime']>;
  isDaylightSavingsTime?: Maybe<Scalars['Boolean']>;
  nurseryRooms?: Maybe<Array<Maybe<NurseryRoomType>>>;
  requestServerDatetime?: Maybe<Scalars['DateTime']>;
};

/** Availability for multiple rooms for a single date  */
export type AvailabilityMultiRoomSingleDateType = {
  __typename?: 'AvailabilityMultiRoomSingleDateType';
  amSessionsAvailable?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['Date']>;
  nurseryRooms?: Maybe<Array<Maybe<NurseryRoomType>>>;
  pmSessionsAvailable?: Maybe<Scalars['Boolean']>;
};

/** Availability for a single date, referenced by NurseryRoomAvailabilityMultiDateType */
export type AvailabilityOnDateType = {
  __typename?: 'AvailabilityOnDateType';
  amAvailability?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['Date']>;
  externalSystemLastUpdated?: Maybe<Scalars['DateTime']>;
  pmAvailability?: Maybe<Scalars['Int']>;
};

export enum AvailabilityType {
  Am = 'AM',
  Full = 'FULL',
  Pm = 'PM'
}

export type BasketActivitySessionType = {
  __typename?: 'BasketActivitySessionType';
  date: Scalars['Date'];
  /** The ISO day of the week this session takes place (Monday=1, Sunday=7). */
  dayOfTheWeek?: Maybe<ActivitySessionDayOfTheWeek>;
  endTime: Scalars['String'];
  id: Scalars['UUID'];
  startTime: Scalars['String'];
};

export type BasketTicketSubscriptionOptionType = {
  __typename?: 'BasketTicketSubscriptionOptionType';
  id: Scalars['UUID'];
  schedule: ActivityScheduleType;
  scheduleSummary: Scalars['String'];
  stripePriceId?: Maybe<Scalars['String']>;
  stripeProductId?: Maybe<Scalars['String']>;
  ticket: TicketType;
  ticketPrice: Scalars['Int'];
};

export type BasketTicketType = {
  __typename?: 'BasketTicketType';
  amount?: Maybe<Scalars['Int']>;
  attendees: Array<ChildType>;
  block?: Maybe<Scalars['UUID']>;
  checksum?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  pricingPolicy?: Maybe<PricingPolicy>;
  schedule?: Maybe<Scalars['UUID']>;
  sessions?: Maybe<Array<Maybe<BasketActivitySessionType>>>;
  subscriptionOption?: Maybe<BasketTicketSubscriptionOptionType>;
  subscriptionTrialEndTimestamp?: Maybe<Scalars['Float']>;
  subscriptionTrialSelected: Scalars['Boolean'];
  ticket: Scalars['UUID'];
  ticketCapacity: Scalars['Int'];
  ticketName: Scalars['String'];
  ticketPrice: Scalars['Int'];
  ticketPricingPolicy?: Maybe<Scalars['String']>;
};

export type BasketType = {
  __typename?: 'BasketType';
  activity?: Maybe<PublicActivityType>;
  addons?: Maybe<Array<Maybe<AttendeeAddonList>>>;
  createdAt: Scalars['DateTime'];
  discount?: Maybe<Scalars['Int']>;
  finalAmount?: Maybe<Scalars['Int']>;
  guardian?: Maybe<NurseryGuardianType>;
  guest?: Maybe<GuestType>;
  hasAddons?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isMarketingConsentGiven: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONString']>;
  originalAmount?: Maybe<Scalars['Int']>;
  product?: Maybe<ProductType>;
  promotion?: Maybe<PromotionType>;
  questionAnswers?: Maybe<Array<Maybe<QuestionAnswerType>>>;
  supplierLinksAccepted?: Maybe<Scalars['Boolean']>;
  supplierMarketingConsentGiven?: Maybe<Scalars['Boolean']>;
  tickets?: Maybe<Array<Maybe<BasketTicketType>>>;
  updatedAt: Scalars['DateTime'];
};

export enum BookingCancellationEnum {
  CircumstanceChange = 'CIRCUMSTANCE_CHANGE',
  Illness = 'ILLNESS',
  ManyFailedPayments = 'MANY_FAILED_PAYMENTS',
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  Other = 'OTHER',
  ParentRequested = 'PARENT_REQUESTED',
  SubscriptionEnded = 'SUBSCRIPTION_ENDED'
}

export enum BookingFilterActionEnum {
  All = 'ALL',
  Confirmed = 'CONFIRMED',
  NeedAction = 'NEED_ACTION',
  OnHold = 'ON_HOLD',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

/** Output of promotionForGuardians and promotionForGuests queries. */
export type BookingPromotionType = {
  __typename?: 'BookingPromotionType';
  /** The amount in pence of the discount */
  discount?: Maybe<Scalars['Int']>;
  /** The amount in pence of the booking with the discount applied */
  finalAmount?: Maybe<Scalars['Int']>;
  /** The promotion id to be used by the booking */
  id?: Maybe<Scalars['UUID']>;
  /** The amount in pence of the booking without the discount applied */
  originalAmount?: Maybe<Scalars['Int']>;
};

export enum BookingRejectionEnum {
  ChildStaffRatio = 'CHILD_STAFF_RATIO',
  LateOnPayments = 'LATE_ON_PAYMENTS',
  Other = 'OTHER',
  RoomAtCapacity = 'ROOM_AT_CAPACITY',
  StaffAbsence = 'STAFF_ABSENCE'
}

export enum BookingSessionTypeEnum {
  Am = 'AM',
  Full = 'FULL',
  Pm = 'PM'
}

export enum BookingStatusEnum {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum BookingType {
  All = 'ALL',
  MarketplaceActivityBooking = 'MARKETPLACE_ACTIVITY_BOOKING',
  SessionNonPrimary = 'SESSION_NON_PRIMARY',
  SessionPrimary = 'SESSION_PRIMARY'
}

export enum BookingTypeEnum {
  MarketplaceActivity = 'MARKETPLACE_ACTIVITY',
  Session = 'SESSION'
}

export enum BookingTypesEnum {
  Enquiry = 'ENQUIRY',
  Instant = 'INSTANT',
  Subscription = 'SUBSCRIPTION'
}

export enum BusinessTypeEnum {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

/**
 * ### Cancellation
 * Given the ID of a booking request, tries to cancel.
 * Note that a Guardian can cancel approved bookings, whether paid-for or not.
 *
 * ### Payments
 * If this is a pending paid-for booking then no payment has been taken, so there is no payment to cancel.
 *
 * If this is an approved paid-for booking then payments have been taken, funds received.
 * We no longer have a payment intent sat awaiting capture until request approved, so there is no way to cancel
 * the payment. we would have to issue a refund transaction via Stripe, however that is currently out of scope.
 *
 * ### Errors
 * `UNAUTHORISED_GUARDIAN_ACTION`: When the guardian cancelling is not the guardian who created the booking.
 *
 * `SESSION_BOOKING_ALREADY_CANCELLED`: When attempting to cancel an already cancelled booking.
 *
 * `INVALID_PAYLOAD`: Occurs when `cancellation_reason` is "Other" but `cancellation_details` are missing.
 */
export type CancelSessionBookingMutation = {
  __typename?: 'CancelSessionBookingMutation';
  bookingRequest?: Maybe<SessionBookingRequestType>;
};

/**
 * ### Cancellation
 * Given the subscription ID and the reason, this class is responsible for cancelling a subscription type
 * activity in marketplace.
 *
 * `Suppliers`: Can initiate the subscription cancel process anytime, by calling the mutation.
 *
 * `Default`: Cancels the subscription at the end of the current billing period (that is, for the duration
 * of time the customer has already paid for).
 */
export type CancelSubscriptionBooking = {
  __typename?: 'CancelSubscriptionBooking';
  subscriptionRequest?: Maybe<SubscriptionBookingCancellationType>;
};

export enum CancellationReason {
  CustomerRequested = 'CUSTOMER_REQUESTED',
  FullActivityCancelled = 'FULL_ACTIVITY_CANCELLED',
  Other = 'OTHER',
  SessionCancelled = 'SESSION_CANCELLED'
}

export type CategoryType = {
  __typename?: 'CategoryType';
  id: Scalars['UUID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export enum CheckoutKeyEnum {
  Block = 'block',
  ManuallyAdded = 'manually_added',
  Schedule = 'schedule',
  Session = 'session',
  Sessions = 'sessions',
  Transferred = 'transferred'
}

export type CheckoutSessionMetadataType = {
  __typename?: 'CheckoutSessionMetadataType';
  checkoutSessionId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONString']>;
  mode?: Maybe<Scalars['String']>;
};

export type ChildAdditionalInfoType = {
  __typename?: 'ChildAdditionalInfoType';
  fullName: Scalars['String'];
  id: Scalars['UUID'];
};

/**
 * For use by Guardians to create a new child.
 *
 * ### Properties that a Guardian can set during creation
 * Any property related to a field of the `ChildrenInput` type,
 * with the exception of the childs 'id' - this is for the update mutation to use.
 *
 * ### Errors
 * `NURSERY_DOES_NOT_EXIST`: Primary or Associated Nursery does not match a nursery in our system.
 *
 * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
 */
export type ChildCreateMutation = {
  __typename?: 'ChildCreateMutation';
  child?: Maybe<ChildType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum ChildStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Deactivated */
  Deactivated = 'DEACTIVATED',
  /** Pending */
  Pending = 'PENDING',
  /** Unrecognized */
  Unrecognized = 'UNRECOGNIZED'
}

export enum ChildStatusEnum {
  Approved = 'APPROVED',
  Deactivated = 'DEACTIVATED',
  Pending = 'PENDING',
  Unrecognized = 'UNRECOGNIZED'
}

export type ChildType = {
  __typename?: 'ChildType';
  approvedAt?: Maybe<Scalars['DateTime']>;
  birthDate?: Maybe<Scalars['Date']>;
  bookingsConfirmedCount?: Maybe<Scalars['Int']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  externalSystemActive: Scalars['Boolean'];
  externalSystemId?: Maybe<Scalars['String']>;
  externalSystemLastUpdated?: Maybe<Scalars['DateTime']>;
  fullName: Scalars['String'];
  guardian?: Maybe<GuardianType>;
  guest?: Maybe<GuestType>;
  id: Scalars['UUID'];
  /** If true, it enables instant book functionality for nursery sessions at child level. */
  instantBook: Scalars['Boolean'];
  instantBookLastUpdated?: Maybe<Scalars['String']>;
  instantBookLastUpdatedBy?: Maybe<NurseryAdminType>;
  isAdult: Scalars['Boolean'];
  isExternallyManaged?: Maybe<Scalars['Boolean']>;
  isRegisteredWithNursery?: Maybe<Scalars['Boolean']>;
  primaryNursery?: Maybe<NurseryType>;
  primaryNurseryPriceList?: Maybe<Array<Maybe<PriceListByChildType>>>;
  primaryNurseryRoom?: Maybe<NurseryRoomType>;
  status: ChildStatus;
  unrecognizedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * For use by Guardians to update most properties of a child.
 *
 * ### Properties that a Guardian can update
 * Any property related to a field of the `ChildrenInput` type,
 * with the exception of the childs 'id'.
 *
 * ### Errors
 * `CHILD_DOES_NOT_EXIST`: Child identifier does not match a child in our system.
 *
 * `UNAUTHORISED_GUARDIAN_ACTION`: Guardian is not the guardian of the Child passed in.
 *
 * `NURSERY_DOES_NOT_EXIST`: Primary or Associated Nursery does not match a nursery in our system.
 *
 * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
 *
 * `SCHOOL_DOES_NOT_EXIST`: School does not match a nursery room in our system.
 */
export type ChildUpdateByGuardianMutation = {
  __typename?: 'ChildUpdateByGuardianMutation';
  child?: Maybe<ChildType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * For use by NurseryAdmins to update specific properties of a child.
 *
 * ### Properties that a NurseryAdmin can update
 * `primary_nursery_room` (for children with a primary_nursery only)
 * `status`
 * `birth_date`
 *
 * ### Errors
 * `CHILD_DOES_NOT_EXIST`: Child identifier does not match a child in our system.
 *
 * `UNAUTHORISED_NURSERY_ADMIN_ACTION`: NurseryAdmin does not have membership to
 * the nursery that is related to the room in the parameters passed in OR
 * the NurseryAdmin does not have membership to the nursery that the child is associated to.
 *
 * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
 */
export type ChildUpdateByNurseryAdminMutation = {
  __typename?: 'ChildUpdateByNurseryAdminMutation';
  child?: Maybe<ChildType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Input for creating or updating a child object */
export type ChildrenInput = {
  birthDate?: Maybe<Scalars['Date']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isAdult?: Maybe<Scalars['Boolean']>;
  primaryNurseryId?: Maybe<Scalars['UUID']>;
  primaryNurseryRoomId?: Maybe<Scalars['UUID']>;
};

export type CreateBasketInputType = {
  activity: Scalars['UUID'];
  tickets?: Maybe<Array<Maybe<CreateTicketsInputType>>>;
  utmMeta?: Maybe<UtmParamsInputType>;
};

export type CreateBookingSessionsCancellation = {
  __typename?: 'CreateBookingSessionsCancellation';
  bookingSessions?: Maybe<Array<Maybe<ActivityBookingTicketSessionType>>>;
};

export type CreateFreeActivityBookingInputType = {
  basketId: Scalars['UUID'];
};

/** Creates a free marketplace `INSTANT` activity booking if everything validates/checks out. */
export type CreateFreeActivityBookingMutation = {
  __typename?: 'CreateFreeActivityBookingMutation';
  booking?: Maybe<ActivityBookingSchemaType>;
};

export type CreateMarketplaceRefund = {
  __typename?: 'CreateMarketplaceRefund';
  refund?: Maybe<RefundType>;
};

export type CreateMarketplaceRefundInputType = {
  bookingSessionIds: Array<Maybe<Scalars['UUID']>>;
  reason: Reason;
  reasonDetails?: Maybe<Scalars['String']>;
  refundAmount: Scalars['Int'];
  supplierId: Scalars['UUID'];
};

/**
 * Creates a payment method held within Stripe for use by the Guardian in question.
 *
 * ### ERRORS
 * `PAYMENT_SETUP_INTENT_FAILED`: Occurs when a failure encountered within the
 * stripe wrapper class; `StripeApiWrapper`.
 */
export type CreatePaymentMethodMutation = {
  __typename?: 'CreatePaymentMethodMutation';
  addAdditionalCard?: Maybe<PaymentType>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateTicketsInputType = {
  attendees?: Maybe<Array<Maybe<AttendeeInputType>>>;
  block?: Maybe<Scalars['UUID']>;
  checksum?: Maybe<Scalars['String']>;
  schedule?: Maybe<Scalars['UUID']>;
  sessions?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  subscriptionTrialSelected?: Maybe<Scalars['Boolean']>;
  ticket: Scalars['UUID'];
};

export type CreateUnpaidBookingInputType = {
  activity: Scalars['UUID'];
  guest: GuestInputType;
  tickets: Array<Maybe<CreateTicketsInputType>>;
};

/** Creates an unpaid marketplace `INSTANT` activity booking */
export type CreateUnpaidBookingMutation = {
  __typename?: 'CreateUnpaidBookingMutation';
  created?: Maybe<Scalars['Boolean']>;
};

export type CreateWaitListRequestInputType = {
  activity: Scalars['UUID'];
  attendeeCount: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  manualActivityDate?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  product?: Maybe<ProductInputType>;
};

export type CreateWaitListRequestMutation = {
  __typename?: 'CreateWaitListRequestMutation';
  created?: Maybe<Scalars['Boolean']>;
};

export type CustomAddonType = {
  __typename?: 'CustomAddonType';
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

export enum CustomSessionTypeAvailabilityType {
  /** Morning */
  Am = 'AM',
  /** Full Day */
  Full = 'FULL',
  /** Afternoon */
  Pm = 'PM'
}

export type CustomSessionTypeModelType = {
  __typename?: 'CustomSessionTypeModelType';
  availabilityType: CustomSessionTypeAvailabilityType;
  endTime: Scalars['Time'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  /** If set to True instant bookings will not be possible against this Custom Session Type */
  requestOnly: Scalars['Boolean'];
  startTime: Scalars['Time'];
};

export type CustomSessionTypesForChildType = {
  __typename?: 'CustomSessionTypesForChildType';
  availabilityType?: Maybe<AvailabilityType>;
  endTime?: Maybe<Scalars['Time']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  requestOnly?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['Time']>;
};

export type CustomerEmailsFromPastBookingsType = {
  __typename?: 'CustomerEmailsFromPastBookingsType';
  children?: Maybe<Array<Maybe<ChildType>>>;
  customerEmail?: Maybe<Scalars['String']>;
  customerFullName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['UUID']>;
};

export type DateAvailabilityType = {
  __typename?: 'DateAvailabilityType';
  date: Scalars['Date'];
  endTime: Scalars['String'];
  isInPast: Scalars['Boolean'];
  spotsLeft: Scalars['Int'];
  startTime: Scalars['String'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/**
 * Delete previously created activity attendee note.
 * Only supplier admin who has access to supplier can delete an attendee note.
 */
export type DeleteActivityAttendeeNoteMutation = {
  __typename?: 'DeleteActivityAttendeeNoteMutation';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * ### Delete All Payment methods For Guardian
 * Given a Guardian ID, tries to delete ALL Payment methods for the relevant Guardian.
 *
 * If Guardian.is_test_guardian == True, allow the operation, else raise an error.
 *
 * This mutation only exists for automated testing of the front-end, so that these tests can
 * clean up after themselves and not pollute our database with unnecessary test payment methods.
 *
 * Relies on feature flag `ALLOW_TEST_PAYMENT_METHODS_DELETIONS`.
 *
 * ### Errors
 * `GUARDIAN_DOES_NOT_EXIST`: Guardian ID does not exist in our system.
 *
 * `UNAUTHORISED_NURSERY_ADMIN_ACTION`:
 * When the Guardian with the ID passed in is NOT a test guardian.
 * Or the feature flag `ALLOW_TEST_PAYMENT_METHODS_DELETIONS` is not set to `ON`.
 */
export type DeleteAllPaymentMethodsMutation = {
  __typename?: 'DeleteAllPaymentMethodsMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteWaitlistMemberMutation = {
  __typename?: 'DeleteWaitlistMemberMutation';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type EmailInvitationMutation = {
  __typename?: 'EmailInvitationMutation';
  sent?: Maybe<Scalars['Boolean']>;
};

/** Class used for a nicer error formatting sent to the frontend  */
export type ErrorType = {
  __typename?: 'ErrorType';
  code?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['GenericScalar']>;
  message?: Maybe<Scalars['String']>;
};

/** Input for defining a rectangle in geo coordinates.Accepts coordinates of opposite corners of the rectangle (SE and NW or NE and SW) */
export type GeoBoundsInput = {
  lat1: Scalars['Float'];
  lat2: Scalars['Float'];
  lng1: Scalars['Float'];
  lng2: Scalars['Float'];
};

export type GetRefundReceiptType = {
  __typename?: 'GetRefundReceiptType';
  booking?: Maybe<ActivityBookingSchemaType>;
  refundAmount?: Maybe<Scalars['Int']>;
  refundableSessions?: Maybe<Array<Maybe<ActivityBookingTicketSessionType>>>;
};

export type GuardianCreateMutation = {
  __typename?: 'GuardianCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  guardian?: Maybe<GuardianType>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum GuardianStatus {
  /** Approved */
  Approved = 'APPROVED',
  /** Deactivated */
  Deactivated = 'DEACTIVATED',
  /** Pending */
  Pending = 'PENDING',
  /** Randomised */
  Randomised = 'RANDOMISED',
  /** Rejected */
  Rejected = 'REJECTED'
}

export enum GuardianStatusEnum {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type GuardianType = {
  __typename?: 'GuardianType';
  anyChildrenExternallyManaged?: Maybe<Scalars['Boolean']>;
  bookingRequests?: Maybe<Array<Maybe<SessionBookingRequestType>>>;
  canBookChildcare?: Maybe<Scalars['Boolean']>;
  canBookMarketplaceActivities?: Maybe<Scalars['Boolean']>;
  children?: Maybe<Array<Maybe<ChildType>>>;
  cognitoId?: Maybe<Scalars['UUID']>;
  cognitoLastAuthTime?: Maybe<Scalars['DateTime']>;
  cognitoUserPoolId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  externalSystemActive: Scalars['Boolean'];
  externalSystemId?: Maybe<Scalars['String']>;
  externalSystemLastUpdated?: Maybe<Scalars['DateTime']>;
  fullName: Scalars['String'];
  id: Scalars['UUID'];
  marketingOptIn?: Maybe<Scalars['Boolean']>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethodType>>>;
  phoneNumber: Scalars['String'];
  status: GuardianStatus;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type GuardianUpdateMutation = {
  __typename?: 'GuardianUpdateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  guardian?: Maybe<GuardianType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GuestInputType = {
  email: Scalars['String'];
  fullName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type GuestType = {
  __typename?: 'GuestType';
  children?: Maybe<Array<Maybe<ChildType>>>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['UUID'];
  /** True indicates the Guest provided consent during checkout */
  isDataConsentGiven: Scalars['Boolean'];
  marketingOptIn?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
  stripeCustomerId?: Maybe<Scalars['String']>;
};

/**
 * Paid session bookings now use Stripe checkout.
 * This mutation creates a Stripe checkout session and returns the URL to a Stripe hosted page for either;
 * a) taking payment or
 * b) validating payment details
 * depending on whether the booking is of type a) instant or b) request.
 *
 * ### Errors
 * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
 *
 * `CHILD_MISSING_BIRTH_DATE`: As code describes, lack of birth date will prevent retrieval of price for session.
 *
 * `CHILD_DOES_NOT_BELONG_TO_GUARDIAN`: Occurs when the child's guardian is not the the same
 * as the guardian provided via the context.
 *
 * `UNAUTHORISED_ACTION`: Either Child.Status in [ UNRECOGNIZED, DEACTIVATED ] or Guardian.Status == REJECTED
 *
 * `NURSERY_PAYMENT_NOT_SETUP`: Occurs when no stripe account associated to the nursery.
 *
 * `ORGANIZATION_DIFFERS_FROM_PRIMARY`: SessionBooking is for a non-primary nursery room but the
 * organization of the requested room's nursery differs from that of the childs primary nursery.
 *
 * `NON_PRIMARY_BOOKINGS_DISABLED`: SessionBooking is for a non-primary nursery room in the same
 * organization, but the nursery the room belongs to has not enabled non-primary bookings.
 *
 * `NURSERY_DOES_NOT_HAVE_CUSTOM_SESSIONS_ENABLED`: Paid for bookings via Stripe are only valid for nurseries with
 * custom sessions enabled as we are deprecating standard session types.
 *
 * `SESSION_TYPE_DOES_NOT_BELONG_TO_NURSERY`: Custom session type passed does not belong to the nursery that
 * the provided room belongs to.
 *
 * `BOOKING_ALREADY_EXISTS`: If a PENDING or ON_HOLD session booking for the same date, child and room
 * already exists then this constitutes an 'overbooking' as 1 child can't be in 2 places/sessions at once.
 *
 * `BOOKING_WITHIN_CUTOFF_PERIOD`: SessionBooking request made for a session starting within the
 * defined cutoff period of the nursery. Period can be specified in either regular or business
 * hours.
 *
 * `INVALID_BOOKING_TO_CANCEL`: For non-primary bookings we may be passed an ID for a PENDING or ON_HOLD session
 * for the same child and date to cancel (due to the guardian making this instant non-primary booking instead). If
 * we are passed the booking_to_cancel ID but cant find it, throw an error.
 *
 * `AMOUNT_COULD_NOT_BE_CALCULATED`: Occurs when booking amount cannot be calculated, can
 * happen when child missing birth date and/or nursery custom session price missing/incomplete.
 *
 * `ERROR_CREATING_CHECKOUT_SESSION`: Occurs when Stripe cannot create a checkout session to initiate the booking.
 */
export type InitiatePaidSessionBookingMutation = {
  __typename?: 'InitiatePaidSessionBookingMutation';
  sessionBookingStripeCheckout?: Maybe<SessionBookingStripeCheckoutType>;
};

export type InitiatePonchoPayCheckoutType = {
  __typename?: 'InitiatePonchoPayCheckoutType';
  redirectUrl: Scalars['String'];
};

export enum LocationCountry {
  /** United Kingdom */
  Uk = 'UK'
}

export type LocationForSupplierType = {
  __typename?: 'LocationForSupplierType';
  id?: Maybe<Scalars['UUID']>;
  location?: Maybe<LocationType>;
  numberOfActivities?: Maybe<Scalars['Int']>;
  usage?: Maybe<Scalars['String']>;
};

export type LocationType = {
  __typename?: 'LocationType';
  additionalInfo?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: LocationCountry;
  id: Scalars['UUID'];
  /** Latitude must be set to enable Geolocation */
  latitude?: Maybe<Scalars['Decimal']>;
  /** Longitude must be set to enable Geolocation */
  longitude?: Maybe<Scalars['Decimal']>;
  /** Location name, e.g. Church or Hall name */
  name?: Maybe<Scalars['String']>;
  postCode: Scalars['String'];
};

/**
 * To resolve a location as part of the activity mutations we must explicitly
 * declare the lat and lng as `String` to prevent 'Received not compatible Decimal' errors.
 */
export type LocationTypeWithResolvedCoordinates = {
  __typename?: 'LocationTypeWithResolvedCoordinates';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: LocationCountry;
  id: Scalars['UUID'];
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  postCode: Scalars['String'];
};

/** Input for creating an activity */
export type MarketplaceActivityCreateInput = {
  additionalImageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  addons?: Maybe<Array<Maybe<AddonInput>>>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  ageMonthsEnd: Scalars['Int'];
  ageMonthsStart: Scalars['Int'];
  allowBlockBookings?: Maybe<Scalars['Boolean']>;
  allowIndividualBookings?: Maybe<Scalars['Boolean']>;
  blocks?: Maybe<Array<Maybe<ActivityBlockInput>>>;
  bookingType: BookingTypesEnum;
  categoryIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  city?: Maybe<Scalars['String']>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  customEmailHeader?: Maybe<Scalars['String']>;
  customEmailImageId?: Maybe<Scalars['String']>;
  customEmailMessage?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  email: Scalars['String'];
  enableRegisterCheckinCheckoutMode?: Maybe<Scalars['Boolean']>;
  enquiryBookingUrl?: Maybe<Scalars['String']>;
  enquiryPrice?: Maybe<Scalars['Int']>;
  guardianToProvide?: Maybe<Scalars['String']>;
  hideEndTimes?: Maybe<Scalars['Boolean']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['String']>;
  locationAdditionalInfo?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  memberships?: Maybe<Array<Maybe<MarketplaceActivityMembershipInput>>>;
  name: Scalars['String'];
  offDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  ofstedUrn?: Maybe<Scalars['String']>;
  onlinePrivateInfo?: Maybe<Scalars['String']>;
  onlinePublicInfo?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  schedules?: Maybe<Array<Maybe<MarketplaceActivityScheduleInput>>>;
  sessions?: Maybe<Array<Maybe<MarketplaceActivityCreateSessionInput>>>;
  showEmail?: Maybe<Scalars['Boolean']>;
  showEnquiryBookingUrl?: Maybe<Scalars['Boolean']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']>;
  status?: Maybe<StatusEnum>;
  subscriptionInfo?: Maybe<Scalars['String']>;
  subscriptionStart?: Maybe<Scalars['Date']>;
  subscriptionTrialPrice?: Maybe<Scalars['Int']>;
  subscriptionTrialSessionCount?: Maybe<Scalars['Int']>;
  subscriptionTrialType?: Maybe<SubscriptionTrialType>;
  supplierId: Scalars['UUID'];
  supplierLocationId?: Maybe<Scalars['UUID']>;
  supplierToProvide?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['UUID']>;
  tickets?: Maybe<ActivityTicketsInput>;
};

export type MarketplaceActivityCreateSessionInput = {
  addons?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  capacity?: Maybe<Scalars['Int']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  id?: Maybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
};

/** Input for updating activity memberships */
export type MarketplaceActivityMembershipInput = {
  activityRegistersAccess: Scalars['Boolean'];
  /** Supplier admin membership id */
  id: Scalars['UUID'];
};

/** Input for activity schedule */
export type MarketplaceActivityScheduleInput = {
  capacity: Scalars['Int'];
  dayOfTheWeek: DayOfWeek;
  endTime: Scalars['Time'];
  id?: Maybe<Scalars['UUID']>;
  startTime: Scalars['Time'];
};

export type MarketplaceActivityType = {
  __typename?: 'MarketplaceActivityType';
  activityType: ActivityTypeEnum;
  /** Enter cloudinary image IDs as a comma separated list */
  additionalImageIds?: Maybe<Array<Scalars['String']>>;
  /** Set to a value greater than Age months start. */
  ageMonthsEnd: Scalars['Int'];
  /** Set to a value greater than or equal to 0. */
  ageMonthsStart: Scalars['Int'];
  ageRange?: Maybe<Scalars['String']>;
  allowBlockBookings: Scalars['Boolean'];
  allowIndividualBookings: Scalars['Boolean'];
  blocks?: Maybe<Array<Maybe<ActivityBlockType>>>;
  /** Select between Enquire or Instant or Subscription booking */
  bookingType: ActivityBookingType;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  /** Will be used for enquiries about this activity */
  email: Scalars['String'];
  /** Price in pence to be displayed on activity cards for activity of booking_type enquire */
  enquiryPrice: Scalars['Int'];
  guardianToProvide?: Maybe<Scalars['String']>;
  hideEndTimes: Scalars['Boolean'];
  id: Scalars['UUID'];
  isOnline: Scalars['Boolean'];
  location?: Maybe<LocationTypeWithResolvedCoordinates>;
  locationAdditionalInfo?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  maxDate?: Maybe<Scalars['Date']>;
  minDate?: Maybe<Scalars['Date']>;
  minTime?: Maybe<Scalars['Time']>;
  name: Scalars['String'];
  offDates?: Maybe<Array<Maybe<ActivityOffDayType>>>;
  /** The Ofsted Unique Reference Number for the Supplier Location of this Activity, required for Poncho Pay */
  ofstedUrn?: Maybe<Scalars['String']>;
  /** Private extra information field for online activities */
  onlinePrivateInfo?: Maybe<Scalars['String']>;
  /** Public extra information field for online activities */
  onlinePublicInfo?: Maybe<Scalars['String']>;
  ponchoPayAccepted?: Maybe<Scalars['Boolean']>;
  schedules?: Maybe<Array<Maybe<ActivityScheduleType>>>;
  sessions?: Maybe<Array<Maybe<ActivitySessionType>>>;
  status: ActivityStatus;
  subscriptionBillingFrequency?: Maybe<ActivitySubscriptionBillingFrequency>;
  subscriptionInfo?: Maybe<Scalars['String']>;
  /** Subscription trial price in pence */
  subscriptionTrialPrice?: Maybe<Scalars['Int']>;
  /** Set to a value between 0 and 3 */
  subscriptionTrialSessionCount?: Maybe<Scalars['Int']>;
  subscriptionTrialType?: Maybe<ActivitySubscriptionTrialType>;
  supplier: MarketplaceSupplierType;
  supplierToProvide?: Maybe<Scalars['String']>;
  /** Term template used for activity blocks and sessions */
  term?: Maybe<TermType>;
  tickets?: Maybe<ActivityTicketType>;
  times?: Maybe<Array<Maybe<StartEndTimeType>>>;
};

/** Input for updating an activity */
export type MarketplaceActivityUpdateInput = {
  additionalImageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  addons?: Maybe<Array<Maybe<AddonInput>>>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  ageMonthsEnd?: Maybe<Scalars['Int']>;
  ageMonthsStart?: Maybe<Scalars['Int']>;
  allowBlockBookings?: Maybe<Scalars['Boolean']>;
  allowIndividualBookings?: Maybe<Scalars['Boolean']>;
  blocks?: Maybe<Array<Maybe<ActivityBlockInput>>>;
  bookingType?: Maybe<BookingTypesEnum>;
  categoryIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  city?: Maybe<Scalars['String']>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  customEmailHeader?: Maybe<Scalars['String']>;
  customEmailImageId?: Maybe<Scalars['String']>;
  customEmailMessage?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  enableRegisterCheckinCheckoutMode?: Maybe<Scalars['Boolean']>;
  enquiryBookingUrl?: Maybe<Scalars['String']>;
  enquiryPrice?: Maybe<Scalars['Int']>;
  guardianToProvide?: Maybe<Scalars['String']>;
  hideEndTimes?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isOnline?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['String']>;
  locationAdditionalInfo?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  memberships?: Maybe<Array<Maybe<MarketplaceActivityMembershipInput>>>;
  name?: Maybe<Scalars['String']>;
  offDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  ofstedUrn?: Maybe<Scalars['String']>;
  onlinePrivateInfo?: Maybe<Scalars['String']>;
  onlinePublicInfo?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  schedules?: Maybe<Array<Maybe<MarketplaceActivityScheduleInput>>>;
  sessions?: Maybe<Array<Maybe<MarketplaceActivityCreateSessionInput>>>;
  showEmail?: Maybe<Scalars['Boolean']>;
  showEnquiryBookingUrl?: Maybe<Scalars['Boolean']>;
  showPhoneNumber?: Maybe<Scalars['Boolean']>;
  status?: Maybe<StatusEnum>;
  subscriptionInfo?: Maybe<Scalars['String']>;
  subscriptionStart?: Maybe<Scalars['Date']>;
  subscriptionTrialPrice?: Maybe<Scalars['Int']>;
  subscriptionTrialSessionCount?: Maybe<Scalars['Int']>;
  subscriptionTrialType?: Maybe<SubscriptionTrialType>;
  supplierLocationId?: Maybe<Scalars['UUID']>;
  supplierToProvide?: Maybe<Scalars['String']>;
  termId?: Maybe<Scalars['UUID']>;
  tickets?: Maybe<ActivityTicketsInput>;
};

export type MarketplaceFranchiseType = {
  __typename?: 'MarketplaceFranchiseType';
  aboutActivity1?: Maybe<Scalars['String']>;
  aboutActivity2?: Maybe<Scalars['String']>;
  aboutActivity3?: Maybe<Scalars['String']>;
  aboutActivity4?: Maybe<Scalars['String']>;
  aboutActivity5?: Maybe<Scalars['String']>;
  activityName1?: Maybe<Scalars['String']>;
  activityName2?: Maybe<Scalars['String']>;
  activityName3?: Maybe<Scalars['String']>;
  activityName4?: Maybe<Scalars['String']>;
  activityName5?: Maybe<Scalars['String']>;
  additionalImageIds?: Maybe<Array<Scalars['String']>>;
  categories: Array<CategoryType>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  franchiseAgeRange?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  instagram?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onlineDetails?: Maybe<Scalars['String']>;
  operatingArea?: Maybe<Scalars['String']>;
  /** Google maps URL for the franchise operating area */
  operatingAreaMapLink?: Maybe<Scalars['String']>;
  /** Unique descriptive reference for a franchise used for Franchise Page URL. */
  slug?: Maybe<Scalars['String']>;
  suppliers?: Maybe<Array<Maybe<MarketplaceSupplierType>>>;
  twitter?: Maybe<Scalars['String']>;
};

/** Input for connecting an existing Stripe account to a Supplier */
export type MarketplaceSupplierConnectStripeInput = {
  authCode: Scalars['String'];
  id: Scalars['UUID'];
};

/** Input for updating a Supplier Link */
export type MarketplaceSupplierLinkInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type MarketplaceSupplierLinkType = {
  __typename?: 'MarketplaceSupplierLinkType';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type MarketplaceSupplierType = {
  __typename?: 'MarketplaceSupplierType';
  aboutUs?: Maybe<Scalars['String']>;
  activitiesLocation?: Maybe<Scalars['String']>;
  activityLocation?: Maybe<LocationTypeWithResolvedCoordinates>;
  additionalImageIds?: Maybe<Array<Scalars['String']>>;
  additionalInformationCaptureEnabled: Scalars['Boolean'];
  /** Set to a value greater than Age months start. */
  ageMonthsEnd?: Maybe<Scalars['Int']>;
  /** Set to a value greater than or equal to 0. */
  ageMonthsStart?: Maybe<Scalars['Int']>;
  ageRange?: Maybe<Scalars['String']>;
  averageRating?: Maybe<Scalars['Float']>;
  categories: Array<CategoryType>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  customEmailImageId?: Maybe<Scalars['String']>;
  customEmailMessage?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  franchise?: Maybe<MarketplaceFranchiseType>;
  hubspotAccountId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  instagram?: Maybe<Scalars['String']>;
  isClaimed?: Maybe<Scalars['Boolean']>;
  justAdded: Scalars['Boolean'];
  keySupplierContactName?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<MarketplaceSupplierLinkType>>>;
  /** The business address for this supplier */
  location?: Maybe<LocationTypeWithResolvedCoordinates>;
  logoImageId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  numberOfRatings?: Maybe<Scalars['Int']>;
  numberOfVenues?: Maybe<Scalars['Int']>;
  paymentAccount?: Maybe<SupplierPaymentAccountType>;
  pebbleUse: PebbleUseChoices;
  phoneNumber?: Maybe<Scalars['String']>;
  ponchoPayFirstSetupAt?: Maybe<Scalars['DateTime']>;
  ponchoPaySetupEmailSentAt?: Maybe<Scalars['DateTime']>;
  ponchoPayStatus?: Maybe<SupplierPonchoPayStatus>;
  reviewsEnabled: Scalars['Boolean'];
  seoPageDescription: Scalars['String'];
  seoPageTitle: Scalars['String'];
  /**
   *
   *         Unique descriptive reference for a supplier used for Supplier and Activity Page URLs.<br/>
   *         If you edit the Supplier name you will trigger an update to this slug and the Supplier Page URL.<br/>
   *         You will also trigger an update to all the Supplier's Activity slugs and URLs.<br/>
   *         WARNING: This may adversely effect the Supplier's Activity Page Search Ranking.
   *
   */
  slug?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** Input for updating a Supplier */
export type MarketplaceSupplierUpdateInput = {
  aboutUs?: Maybe<Scalars['String']>;
  additionalImageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  additionalInformationCaptureEnabled?: Maybe<Scalars['Boolean']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  ageMonthsEnd?: Maybe<Scalars['String']>;
  ageMonthsStart?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  city?: Maybe<Scalars['String']>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  customEmailImageId?: Maybe<Scalars['String']>;
  customEmailMessage?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebook?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  instagram?: Maybe<Scalars['String']>;
  keySupplierContactName?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<MarketplaceSupplierLinkInput>>>;
  logoImageId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type MatchedQuestionAnswerType = {
  __typename?: 'MatchedQuestionAnswerType';
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  question?: Maybe<Question2Type>;
};

export type MeNurseryPortalQueryUnionTypes = NurseryAdminType;

export type MoveAttendeeSessionInputType = {
  activityBookingTicketSession: Scalars['UUID'];
  newSession: Scalars['UUID'];
};

export type Mutations = {
  __typename?: 'Mutations';
  activityCreate?: Maybe<ActivityCreateMutation>;
  activityDelete?: Maybe<ActivityDeleteMutation>;
  activityPublish?: Maybe<ActivityPublishMutation>;
  activityToggleRegisterCheckinCheckoutMode?: Maybe<ActivityToggleRegisterCheckinCheckOutModeMutation>;
  activityUpdate?: Maybe<ActivityUpdateMutation>;
  availabilitiesUpdate?: Maybe<AvailabilitiesUpdateMutation>;
  /**
   * Creates a payment method held within Stripe for use by the Guardian in question.
   *
   * ### ERRORS
   * `PAYMENT_SETUP_INTENT_FAILED`: Occurs when a failure encountered within the
   * stripe wrapper class; `StripeApiWrapper`.
   * @deprecated Superceded by createPaymentMethod as will be used for both session and extra bookings
   */
  bookingCreatePaymentMethod?: Maybe<CreatePaymentMethodMutation>;
  bookingSessions?: Maybe<Array<Maybe<ActivityBookingTicketSessionType>>>;
  /**
   * ### Cancellation
   * Given the ID of a booking request, tries to cancel.
   * Note that a Guardian can cancel approved bookings, whether paid-for or not.
   *
   * ### Payments
   * If this is a pending paid-for booking then no payment has been taken, so there is no payment to cancel.
   *
   * If this is an approved paid-for booking then payments have been taken, funds received.
   * We no longer have a payment intent sat awaiting capture until request approved, so there is no way to cancel
   * the payment. we would have to issue a refund transaction via Stripe, however that is currently out of scope.
   *
   * ### Errors
   * `UNAUTHORISED_GUARDIAN_ACTION`: When the guardian cancelling is not the guardian who created the booking.
   *
   * `SESSION_BOOKING_ALREADY_CANCELLED`: When attempting to cancel an already cancelled booking.
   *
   * `INVALID_PAYLOAD`: Occurs when `cancellation_reason` is "Other" but `cancellation_details` are missing.
   */
  cancelSessionBooking?: Maybe<CancelSessionBookingMutation>;
  /**
   * ### Cancellation
   * Given the subscription ID and the reason, this class is responsible for cancelling a subscription type
   * activity in marketplace.
   *
   * `Suppliers`: Can initiate the subscription cancel process anytime, by calling the mutation.
   *
   * `Default`: Cancels the subscription at the end of the current billing period (that is, for the duration
   * of time the customer has already paid for).
   */
  cancelSubscriptionBooking?: Maybe<CancelSubscriptionBooking>;
  captureAdditionalInfoForBooking?: Maybe<AdditionalInfoType>;
  /**
   * For use by Guardians to create a new child.
   *
   * ### Properties that a Guardian can set during creation
   * Any property related to a field of the `ChildrenInput` type,
   * with the exception of the childs 'id' - this is for the update mutation to use.
   *
   * ### Errors
   * `NURSERY_DOES_NOT_EXIST`: Primary or Associated Nursery does not match a nursery in our system.
   *
   * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
   */
  childCreate?: Maybe<ChildCreateMutation>;
  /**
   * For use by Guardians to update most properties of a child.
   *
   * ### Properties that a Guardian can update
   * Any property related to a field of the `ChildrenInput` type,
   * with the exception of the childs 'id'.
   *
   * ### Errors
   * `CHILD_DOES_NOT_EXIST`: Child identifier does not match a child in our system.
   *
   * `UNAUTHORISED_GUARDIAN_ACTION`: Guardian is not the guardian of the Child passed in.
   *
   * `NURSERY_DOES_NOT_EXIST`: Primary or Associated Nursery does not match a nursery in our system.
   *
   * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
   *
   * `SCHOOL_DOES_NOT_EXIST`: School does not match a nursery room in our system.
   */
  childUpdateByGuardian?: Maybe<ChildUpdateByGuardianMutation>;
  /**
   * For use by NurseryAdmins to update specific properties of a child.
   *
   * ### Properties that a NurseryAdmin can update
   * `primary_nursery_room` (for children with a primary_nursery only)
   * `status`
   * `birth_date`
   *
   * ### Errors
   * `CHILD_DOES_NOT_EXIST`: Child identifier does not match a child in our system.
   *
   * `UNAUTHORISED_NURSERY_ADMIN_ACTION`: NurseryAdmin does not have membership to
   * the nursery that is related to the room in the parameters passed in OR
   * the NurseryAdmin does not have membership to the nursery that the child is associated to.
   *
   * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
   */
  childUpdateByNursery?: Maybe<ChildUpdateByNurseryAdminMutation>;
  /**
   *
   *
   */
  createActivityAttendeeNote?: Maybe<ActivityAttendeeNoteType>;
  createBasket?: Maybe<BasketType>;
  createBookingSessionsCancellation?: Maybe<CreateBookingSessionsCancellation>;
  /** Creates a free marketplace `INSTANT` activity booking if everything validates/checks out. */
  createFreeActivityBooking?: Maybe<CreateFreeActivityBookingMutation>;
  createMarketplaceRefund?: Maybe<CreateMarketplaceRefund>;
  /**
   * Creates a payment method held within Stripe for use by the Guardian in question.
   *
   * ### ERRORS
   * `PAYMENT_SETUP_INTENT_FAILED`: Occurs when a failure encountered within the
   * stripe wrapper class; `StripeApiWrapper`.
   */
  createPaymentMethod?: Maybe<CreatePaymentMethodMutation>;
  /** Creates an unpaid marketplace `INSTANT` activity booking */
  createUnpaidBooking?: Maybe<CreateUnpaidBookingMutation>;
  createWaitListRequest?: Maybe<CreateWaitListRequestMutation>;
  /**
   * Delete previously created activity attendee note.
   * Only supplier admin who has access to supplier can delete an attendee note.
   */
  deleteActivityAttendeeNote?: Maybe<DeleteActivityAttendeeNoteMutation>;
  /**
   * ### Delete All Payment methods For Guardian
   * Given a Guardian ID, tries to delete ALL Payment methods for the relevant Guardian.
   *
   * If Guardian.is_test_guardian == True, allow the operation, else raise an error.
   *
   * This mutation only exists for automated testing of the front-end, so that these tests can
   * clean up after themselves and not pollute our database with unnecessary test payment methods.
   *
   * Relies on feature flag `ALLOW_TEST_PAYMENT_METHODS_DELETIONS`.
   *
   * ### Errors
   * `GUARDIAN_DOES_NOT_EXIST`: Guardian ID does not exist in our system.
   *
   * `UNAUTHORISED_NURSERY_ADMIN_ACTION`:
   * When the Guardian with the ID passed in is NOT a test guardian.
   * Or the feature flag `ALLOW_TEST_PAYMENT_METHODS_DELETIONS` is not set to `ON`.
   */
  deleteAllPaymentMethods?: Maybe<DeleteAllPaymentMethodsMutation>;
  deleteWaitListMember?: Maybe<DeleteWaitlistMemberMutation>;
  emailInvitationToWaitListMember?: Maybe<EmailInvitationMutation>;
  guardianCreate?: Maybe<GuardianCreateMutation>;
  guardianUpdate?: Maybe<GuardianUpdateMutation>;
  /**
   * Paid session bookings now use Stripe checkout.
   * This mutation creates a Stripe checkout session and returns the URL to a Stripe hosted page for either;
   * a) taking payment or
   * b) validating payment details
   * depending on whether the booking is of type a) instant or b) request.
   *
   * ### Errors
   * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
   *
   * `CHILD_MISSING_BIRTH_DATE`: As code describes, lack of birth date will prevent retrieval of price for session.
   *
   * `CHILD_DOES_NOT_BELONG_TO_GUARDIAN`: Occurs when the child's guardian is not the the same
   * as the guardian provided via the context.
   *
   * `UNAUTHORISED_ACTION`: Either Child.Status in [ UNRECOGNIZED, DEACTIVATED ] or Guardian.Status == REJECTED
   *
   * `NURSERY_PAYMENT_NOT_SETUP`: Occurs when no stripe account associated to the nursery.
   *
   * `ORGANIZATION_DIFFERS_FROM_PRIMARY`: SessionBooking is for a non-primary nursery room but the
   * organization of the requested room's nursery differs from that of the childs primary nursery.
   *
   * `NON_PRIMARY_BOOKINGS_DISABLED`: SessionBooking is for a non-primary nursery room in the same
   * organization, but the nursery the room belongs to has not enabled non-primary bookings.
   *
   * `NURSERY_DOES_NOT_HAVE_CUSTOM_SESSIONS_ENABLED`: Paid for bookings via Stripe are only valid for nurseries with
   * custom sessions enabled as we are deprecating standard session types.
   *
   * `SESSION_TYPE_DOES_NOT_BELONG_TO_NURSERY`: Custom session type passed does not belong to the nursery that
   * the provided room belongs to.
   *
   * `BOOKING_ALREADY_EXISTS`: If a PENDING or ON_HOLD session booking for the same date, child and room
   * already exists then this constitutes an 'overbooking' as 1 child can't be in 2 places/sessions at once.
   *
   * `BOOKING_WITHIN_CUTOFF_PERIOD`: SessionBooking request made for a session starting within the
   * defined cutoff period of the nursery. Period can be specified in either regular or business
   * hours.
   *
   * `INVALID_BOOKING_TO_CANCEL`: For non-primary bookings we may be passed an ID for a PENDING or ON_HOLD session
   * for the same child and date to cancel (due to the guardian making this instant non-primary booking instead). If
   * we are passed the booking_to_cancel ID but cant find it, throw an error.
   *
   * `AMOUNT_COULD_NOT_BE_CALCULATED`: Occurs when booking amount cannot be calculated, can
   * happen when child missing birth date and/or nursery custom session price missing/incomplete.
   *
   * `ERROR_CREATING_CHECKOUT_SESSION`: Occurs when Stripe cannot create a checkout session to initiate the booking.
   */
  initiatePaidSessionBooking?: Maybe<InitiatePaidSessionBookingMutation>;
  /** Returns the `redirectUrl` to initiate a Poncho Pay payment provided the `basket_id` */
  initiatePonchoPayCheckout?: Maybe<InitiatePonchoPayCheckoutType>;
  moveAttendeeSession?: Maybe<AttendeeSessionMovedType>;
  nurseryPaymentAccountCreate?: Maybe<NurseryPaymentAccountCreateMutation>;
  refund?: Maybe<RefundType>;
  /**
   * ### Delete All Bookings For Guardian
   * Given a Guardian ID, tries to delete ALL Bookings for the relevant Guardian.
   *
   * If Guardian.is_test_guardian == True, allow the operation, else raise an error.
   *
   * This mutation only exists for automated testing of the front-end, so that these tests can
   * clean up after themselves and not pollute our database with unnecessary test bookings.
   *
   * Relies on feature flag `ALLOW_TEST_BOOKING_DELETIONS`.
   *
   * ### Errors
   * `GUARDIAN_DOES_NOT_EXIST`: Guardian ID does not exist in our system.
   *
   * `UNAUTHORISED_NURSERY_ADMIN_ACTION`: When the Guardian with the ID passed in
   * is NOT a test guardian. Or the feature flag `ALLOW_TEST_BOOKING_DELETIONS` is not set to `ON`.
   */
  sessionBookingDeleteAllForGuardian?: Maybe<SessionBookingDeleteMutation>;
  /**
   * ###
   * Creates a session booking request for a child in a specific nursery time slot.
   *
   * Instant bookings are created if;
   * - the child's status is APPROVED
   * - the child's 'instant_book' field is set to True
   * - the nursery's 'allow_only_booking_requests' field is set to False
   * - AND there is availability for the room specified (or if not specified, the child's primary room).
   *
   * We trigger the sending of an email to the nursery with details of newly created booking.
   *
   * Optionally accepts a room, which can be a room from another nursery in
   * the same organisation as the child's primary nursery.
   *
   * ### Payment required?
   * If a payment is required we raise an error here of type PAID_BOOKING_NOT_ALLOWED_HERE,
   * as the InitiatePaidSessionBookingMutation mutation should be used instead of this mutation.
   *
   * We determine whether payment is required or not by the `payments_enabled` field of the Nursery
   * that is related to the `room` parameter & the `paymentExepmtionReason` value as well as the `amount`
   * calculated after the application of any valid promotion redeemed by the guardian.
   * 100% discounts are possible, in this case no payment would be taken even if the nursery has payments
   * enabled and the booking is not exempt.
   *
   * #### Non-paid bookings
   * If instant, booking is confirmed here, if request booking status is left at PENDING,
   * and the booking then may be approved or rejected later by a NurseryAdmin in the NAWA.
   *
   * #### Paid-for booking
   * - If `setupIntentId` is passed this is retrieved from Stripe.
   *     - if setup intent 'succeeded' the payment method associated to this is used and set as Guardian's default
   *     - else the setup intent is cancelled and Guardian's default payment method is used
   *
   * - If `setupIntentId` is not passed.
   *     - Guardian's default payment method is used
   *
   * ##### Instant
   * A payment intent is created and confirmed immediately using the appropriate payment method.
   *
   * ##### Request
   * We will store the selected payment method on the booking request so that it can be used to take payment later
   * if the request is approved by a NurseryAdmin.
   *
   * ### Previous booking cancellations
   * If `bookingToCancel` is provided and this is a non-primary booking and there is a match for a similar booking for
   * the same child and date - the booking with the provided ID is cancelled
   *
   * ### External system integration (NurseryCare)
   * If the booking is for a room in a nursery of the relevant organization (Busy Bees), then we will attempt to
   * create a booking in an external system as well. On success this returns updated availability data for our system.
   *
   * ### Force request
   * If `forceRequest` parameter is supplied as True we will create a request booking instead of an instant booking.
   *
   * ### Errors
   * `BOOKING_ALREADY_EXISTS`: When another similar or overlapping booking exists.
   *
   * `CHILD_DOES_NOT_EXIST`: Child identifier does not match a child in our system.
   *
   * `UNAUTHORISED_ACTION`: Guardian's status is `REJECTED`,
   * or child's status is `UNRECOGNIZED` or `DEACTIVATED`.
   *
   * `NURSERY_DOES_NOT_EXIST`: Nursery identifier does not match a nursery in our system.
   *
   * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
   *
   * `ORGANIZATION_DIFFERS_FROM_PRIMARY`: SessionBooking is for a non-primary nursery room but the
   * organization of the requested room's nursery differs from that of the childs primary nursery.
   *
   * `NON_PRIMARY_BOOKINGS_DISABLED`: SessionBooking is for a non-primary nursery room in the same
   * organization, but the nursery the room belongs to has not enabled non-primary bookings.
   *
   * `BOOKING_WITHIN_CUTOFF_PERIOD`: SessionBooking request made for a session starting within the
   * defined cutoff period of the nursery. Period can be specified in either regular or business
   * hours.
   *
   * `BOTH_SESSION_TYPE_AND_CUSTOM_SESSION_TYPE_PROVIDED`: Both SessionType and CustomSessionType passed
   * as parameters, we can only accept one of these.
   *
   * `SESSION_TYPE_NOT_PROVIDED`: When nursery.is_custom_session_bookings_enabled is False,
   * SessionType must be provided.
   *
   * `CUSTOM_SESSION_TYPE_NOT_PROVIDED`: When nursery.is_custom_session_bookings_enabled is True,
   * CustomSessionType must be provided.
   *
   * `NO_PAYMENT_METHOD_FOUND`: When this mutation cannot determine a payment method for a paid-for booking.
   *
   * `EXTERNAL_SESSION_BOOKING_ERROR`: Error creating session booking in external booking system API.
   *
   * `EXTERNAL_RESOURCE_NOT_FOUND`: Call to external booking system returned a 404, either child or room not recognised.
   *
   * `INVALID_EXTERNAL_DATA_SESSION_BOOKING_CREATE`: Error encountered during attempt to save returned data
   * from external booking system (NurseryCare).
   *
   * `PAYMENT_NOT_CREATED`: When error creating a new payment intent for a paid-for instant booking.
   *
   * `PAYMENT_NOT_MODIFIED`: When error updating the payment intent metadata with the booking_id.
   *
   * `PAYMENT_NOT_CAPTURED`: When there is an error capturing the payment intent for a paid-for instant booking.
   */
  submitSessionBooking?: Maybe<SubmitSessionBookingMutation>;
  /** Creates and sends/schedules a booking request/invitation to input email(s) in order to book with Pebble. */
  supplierBookingRequestCreate?: Maybe<SupplierBookingRequestCreateMutation>;
  supplierConnectExistingStripeAccount?: Maybe<SupplierConnectExistingStripeAccountMutation>;
  supplierLocationCreate?: Maybe<SupplierLocationCreateMutation>;
  supplierLocationDelete?: Maybe<SupplierLocationDeleteMutation>;
  supplierLocationUpdate?: Maybe<SupplierLocationUpdateMutation>;
  /**
   * Creates a (supplier, supplier admin) membership.
   *
   * 1. If supplier admin does not exist in DB, it creates a supplier admin instance and the membership.
   *     When the supplier admin signs up with Pebble, a cognito user will be auto-assigned to supplier admin instance.
   * 2. If supplier admin exists in DB, it creates the membership with the supplier
   * 3. If supplier (supplier admin, supplier) membership exists returns the existing one.
   *
   * Params:
   *     supplier_id(str): Supplier ID
   *     supplier_admin_full_name(str): Supplier Admin's full name
   *     supplier_admin_email(str): Supplier Admin's email
   *     admin_access(enum): Admin access options to select from. If field excluded, supplier admin grants full access
   * Returns:
   *     SupplierAdminMembership(obj): The created Supplier, SupplierAdmin membership
   */
  supplierMembershipCreate?: Maybe<SupplierMembershipCreateMutation>;
  supplierMembershipDelete?: Maybe<SupplierMembershipDeleteMutation>;
  /**
   * Updates supplier membership admin access levels.
   *
   * Params:
   *     supplier_id(str): Supplier ID
   *     supplier_admin_id(str): Supplier Admin's ID
   *     admin_access(list): Admin access options to select from. If field excluded, supplier admin grants full access
   * Returns:
   *     SupplierAdminMembership(obj): The updated Supplier, SupplierAdmin membership
   */
  supplierMembershipUpdate?: Maybe<SupplierMembershipUpdateMutation>;
  supplierPaymentAccountCreate?: Maybe<SupplierPaymentAccountCreateMutation>;
  supplierRequestPonchoPay?: Maybe<SupplierRequestPonchoPayMutation>;
  supplierUpdate?: Maybe<SupplierUpdateMutation>;
  termCreate?: Maybe<TermCreateMutation>;
  termDelete?: Maybe<TermDeleteMutation>;
  transferWaitListMember?: Maybe<TransferWaitListMemberMutation>;
  updateActivitySessionAttendance?: Maybe<ActivityBookingTicketSessionType>;
  updateBasket?: Maybe<BasketType>;
  /**
   * ###
   * Requests Busy Bees NurseryRoomAvailability for specific date from NurseryCare API,
   * uses returned data to update our NurseryRoomAvailability model.
   *
   * ### Exceptions
   * Raises NurseryCareApiRateLimitException when status code of response from Nursery Care API is 429
   * (Too Many Requests). This is raised/thrown rather than handled and returned as a GraphQL Error to
   * allow the consumer to handle as a network error and implement backoff/retry functionality.
   *
   * ### GraphQL Errors
   * `UNAUTHORISED_GUARDIAN_ACTION`: When guardian not found in context, indicates a problem with authentication.
   * Also raised if guardian status is REJECTED.
   *
   * `NURSERY_NOT_MANAGED_VIA_EXTERNAL_SYSTEM`: When the room in question does not belong to a nursery from an
   * organisation that is being actively managed via integration with an external system.
   *
   * `EXTERNAL_ID_MISSING`: When room does belong to a nursery whose organization is externally managed,
   * but the room has no external_system_id value.
   *
   * `EXTERNAL_AVAILABILITY_ERROR`: When an error occurs with the NurseryCare api called.
   *
   * `EXTERNAL_RESOURCE_NOT_FOUND`: When room not found by external_system_id, refer to nursery to try and resolve.
   *
   * `ERROR_UPDATING_AVAILABILITY_WITH_EXTERNAL_DATA`: tbc
   *
   * `NO_ROOM_AVAILABILITY`: When external availability is 0 (or less), indicating that we cannot allow instant booking,
   * booking requests can still be made though (these will need approval by a nursery admin before approved/confirmed).
   */
  updateFromExternalAvailability?: Maybe<UpdateFromExternalAvailabilityMutation>;
  /**
   * ### Status update
   * Given the ID of a booking request and the desired status, tries to update its status.
   *
   * If status is changed to `REJECTED` it tries to find alternate session
   * and send SMS notification to the guardian.
   *
   * NurseryAdmin can only CONFIRM or REJECT a booking request, they cannot CANCEL one.
   *
   * ### Payments
   * This mutation creates and captures payment when booking status is changed to `CONFIRMED`.
   * When booking status is changed to `REJECTED` there is no payment processing to undertake.
   *
   * ### Room update
   * If room ID is given, the booking's room is going to be updated,
   * as well as the child's primary nursery room.
   * If the given room ID is not under the child's primary nursery,
   * then only the booking's room updated and the child's room is not.
   *
   * ### Errors
   * `UNAUTHORISED_NURSERY_ADMIN_ACTION`: When the nursery admin making the update request is not
   * the owner of the nursery in question.
   *
   * `INVALID_PAYLOAD`: Occurs when rejecting a booking, if `rejection_reason` is missing,
   * or `rejection_reason` is "Other" but `rejection_details` are missing.
   *
   * `INVALID_FIELD`: Occurs if NurseryAdmin attempts to cancel a booking (only Guardians can cancel their bookings).
   *
   * `SESSION_BOOKING_IN_PAST`: Occurs when attempting to confirm or reject a booking for a date in the past.
   *
   * `SESSION_BOOKING_ALREADY_CONFIRMED`: Occurs when attempting to confirm an already confirmed booking.
   *
   * `PAYMENT_NOT_CREATED`: When error creating a new payment intent for a paid-for booking request.
   *
   * `PAYMENT_NOT_MODIFIED`: When error updating the payment intent metadata with the booking_id.
   *
   * `PAYMENT_NOT_CAPTURED`: When there is an error capturing the payment for a paid-for booking request.
   *
   * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
   *
   * `NURSERY_ROOM_NOT_PROVIDED`: No room set on the booking request, or child and no roomId passed into this mutation.
   *
   * `NURSERY_DIFFERS_FROM_BOOKING`: When room_id is provided for update, but the room belongs to
   * a nursery other than the nursery of the room currently on the booking.
   *
   * `EXTERNAL_SESSION_BOOKING_ERROR`: Error creating session booking in external booking system API.
   *
   * `EXTERNAL_RESOURCE_NOT_FOUND`: Call to external booking system returned a 404, either child or room not recognised.
   *
   * `INVALID_EXTERNAL_DATA_SESSION_BOOKING_CREATE`: Error encountered during attempt to save returned data
   * from external booking system (NurseryCare).
   */
  updateSessionBooking?: Maybe<UpdateSessionBookingMutation>;
};


export type MutationsActivityCreateArgs = {
  input?: Maybe<MarketplaceActivityCreateInput>;
};


export type MutationsActivityDeleteArgs = {
  id: Scalars['UUID'];
};


export type MutationsActivityPublishArgs = {
  input?: Maybe<ActivityPublishInput>;
};


export type MutationsActivityToggleRegisterCheckinCheckoutModeArgs = {
  input?: Maybe<ActivityToggleRegisterCheckinCheckoutModeInput>;
};


export type MutationsActivityUpdateArgs = {
  input?: Maybe<MarketplaceActivityUpdateInput>;
};


export type MutationsAvailabilitiesUpdateArgs = {
  dates?: Maybe<Array<Maybe<AvailabilityDateType>>>;
  roomId?: Maybe<Scalars['UUID']>;
};


export type MutationsCancelSessionBookingArgs = {
  cancellationDetails?: Maybe<Scalars['String']>;
  cancellationReason: BookingCancellationEnum;
  id: Scalars['UUID'];
};


export type MutationsCancelSubscriptionBookingArgs = {
  cancellationDetails?: Maybe<Scalars['String']>;
  cancellationReason: BookingCancellationEnum;
  subscriptionId: Scalars['String'];
};


export type MutationsCaptureAdditionalInfoForBookingArgs = {
  input?: Maybe<AdditionalInfoInputType>;
};


export type MutationsChildCreateArgs = {
  child: ChildrenInput;
};


export type MutationsChildUpdateByGuardianArgs = {
  child: ChildrenInput;
};


export type MutationsChildUpdateByNurseryArgs = {
  birthDate?: Maybe<Scalars['Date']>;
  childId?: Maybe<Scalars['UUID']>;
  instantBook?: Maybe<Scalars['Boolean']>;
  primaryNurseryRoom?: Maybe<Scalars['UUID']>;
  status?: Maybe<ChildStatusEnum>;
};


export type MutationsCreateActivityAttendeeNoteArgs = {
  activityId: Scalars['UUID'];
  attendeeId: Scalars['UUID'];
  text: Scalars['String'];
};


export type MutationsCreateBasketArgs = {
  input?: Maybe<CreateBasketInputType>;
};


export type MutationsCreateBookingSessionsCancellationArgs = {
  bookingSessionIds: Array<Maybe<Scalars['UUID']>>;
  reason: CancellationReason;
  reasonDetails?: Maybe<Scalars['String']>;
};


export type MutationsCreateFreeActivityBookingArgs = {
  input?: Maybe<CreateFreeActivityBookingInputType>;
};


export type MutationsCreateMarketplaceRefundArgs = {
  input?: Maybe<CreateMarketplaceRefundInputType>;
};


export type MutationsCreateUnpaidBookingArgs = {
  input?: Maybe<CreateUnpaidBookingInputType>;
};


export type MutationsCreateWaitListRequestArgs = {
  input: CreateWaitListRequestInputType;
};


export type MutationsDeleteActivityAttendeeNoteArgs = {
  id: Scalars['UUID'];
};


export type MutationsDeleteAllPaymentMethodsArgs = {
  deleteDefault: Scalars['Boolean'];
  guardianId: Scalars['UUID'];
};


export type MutationsDeleteWaitListMemberArgs = {
  id: Scalars['UUID'];
};


export type MutationsEmailInvitationToWaitListMemberArgs = {
  customerMessage?: Maybe<Scalars['String']>;
  id: Array<Maybe<Scalars['UUID']>>;
};


export type MutationsGuardianCreateArgs = {
  children?: Maybe<Array<Maybe<ChildrenInput>>>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  marketingOptIn?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['UUID']>;
};


export type MutationsGuardianUpdateArgs = {
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  guardianId: Scalars['UUID'];
  marketingOptIn?: Maybe<Scalars['Boolean']>;
  status?: Maybe<GuardianStatusEnum>;
};


export type MutationsInitiatePaidSessionBookingArgs = {
  bookingToCancel?: Maybe<Scalars['UUID']>;
  child: Scalars['UUID'];
  customSessionType: Scalars['UUID'];
  date: Scalars['Date'];
  forceRequest?: Maybe<Scalars['Boolean']>;
  promotion?: Maybe<Scalars['UUID']>;
  room?: Maybe<Scalars['UUID']>;
};


export type MutationsInitiatePonchoPayCheckoutArgs = {
  basketId: Scalars['UUID'];
};


export type MutationsMoveAttendeeSessionArgs = {
  input?: Maybe<MoveAttendeeSessionInputType>;
};


export type MutationsNurseryPaymentAccountCreateArgs = {
  nurseryId: Scalars['UUID'];
};


export type MutationsSessionBookingDeleteAllForGuardianArgs = {
  guardianId: Scalars['UUID'];
};


export type MutationsSubmitSessionBookingArgs = {
  additionalNotes?: Maybe<Scalars['String']>;
  bookingToCancel?: Maybe<Scalars['UUID']>;
  child: Scalars['UUID'];
  customSessionType?: Maybe<Scalars['UUID']>;
  date: Scalars['Date'];
  forceRequest?: Maybe<Scalars['Boolean']>;
  paymentExemptionReason?: Maybe<PaymentExemptionReasonEnum>;
  promotion?: Maybe<Scalars['UUID']>;
  room?: Maybe<Scalars['UUID']>;
  sessionType?: Maybe<BookingSessionTypeEnum>;
};


export type MutationsSupplierBookingRequestCreateArgs = {
  activityId: Scalars['UUID'];
  customMessage?: Maybe<Scalars['String']>;
  emails: Array<Maybe<Scalars['String']>>;
  optIn?: Maybe<Scalars['Boolean']>;
  sendAt?: Maybe<Array<Maybe<Scalars['Date']>>>;
};


export type MutationsSupplierConnectExistingStripeAccountArgs = {
  input?: Maybe<MarketplaceSupplierConnectStripeInput>;
};


export type MutationsSupplierLocationCreateArgs = {
  input?: Maybe<SupplierLocationCreateInput>;
};


export type MutationsSupplierLocationDeleteArgs = {
  id: Scalars['UUID'];
};


export type MutationsSupplierLocationUpdateArgs = {
  input?: Maybe<SupplierLocationUpdateInput>;
};


export type MutationsSupplierMembershipCreateArgs = {
  adminAccess?: Maybe<Array<Maybe<SupplierAdminAccessEnum>>>;
  supplierAdminEmail: Scalars['String'];
  supplierAdminFullName: Scalars['String'];
  supplierId: Scalars['UUID'];
};


export type MutationsSupplierMembershipDeleteArgs = {
  supplierAdminId: Scalars['UUID'];
  supplierId: Scalars['UUID'];
};


export type MutationsSupplierMembershipUpdateArgs = {
  adminAccess?: Maybe<Array<Maybe<SupplierAdminAccessEnum>>>;
  supplierAdminId: Scalars['UUID'];
  supplierId: Scalars['UUID'];
};


export type MutationsSupplierPaymentAccountCreateArgs = {
  businessType: BusinessTypeEnum;
  supplierId: Scalars['UUID'];
};


export type MutationsSupplierRequestPonchoPayArgs = {
  input?: Maybe<SupplierRequestPonchoPayInput>;
};


export type MutationsSupplierUpdateArgs = {
  input?: Maybe<MarketplaceSupplierUpdateInput>;
};


export type MutationsTermCreateArgs = {
  input?: Maybe<TermCreateInput>;
};


export type MutationsTermDeleteArgs = {
  id: Scalars['UUID'];
};


export type MutationsTransferWaitListMemberArgs = {
  manualActivityDate: Scalars['String'];
  newActivityId: Scalars['UUID'];
  waitlistRequestId: Scalars['UUID'];
};


export type MutationsUpdateActivitySessionAttendanceArgs = {
  input?: Maybe<UpdateActivitySessionAttendanceInputType>;
};


export type MutationsUpdateBasketArgs = {
  input?: Maybe<UpdateBasketInputType>;
};


export type MutationsUpdateFromExternalAvailabilityArgs = {
  endDate: Scalars['Date'];
  room: Scalars['UUID'];
  startDate: Scalars['Date'];
};


export type MutationsUpdateSessionBookingArgs = {
  deductAvailability?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  rejectionDetails?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<BookingRejectionEnum>;
  roomId?: Maybe<Scalars['UUID']>;
  status: BookingStatusEnum;
};

export type NameEmailInput = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type NurseryAdminType = {
  __typename?: 'NurseryAdminType';
  cognitoId?: Maybe<Scalars['UUID']>;
  cognitoLastAuthTime?: Maybe<Scalars['DateTime']>;
  cognitoUserPoolId?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['UUID'];
  nurseries?: Maybe<Array<Maybe<NurseryType>>>;
};

/** Availability for all rooms in a nursery for a single date  */
export type NurseryAvailabilityMultiRoomSingleDateType = {
  __typename?: 'NurseryAvailabilityMultiRoomSingleDateType';
  date?: Maybe<Scalars['Date']>;
  rooms?: Maybe<Array<Maybe<NurseryAvailabilitySingleRoomSingleDateType>>>;
};

/** Availability for a single nursery room for a single date  */
export type NurseryAvailabilitySingleRoomSingleDateType = {
  __typename?: 'NurseryAvailabilitySingleRoomSingleDateType';
  amAvailability?: Maybe<Scalars['Int']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  nurseryRoom?: Maybe<NurseryRoomType>;
  pmAvailability?: Maybe<Scalars['Int']>;
  remainingAmSpots?: Maybe<Scalars['Int']>;
  remainingPmSpots?: Maybe<Scalars['Int']>;
};

export enum NurseryBookingRequestCutoffWindowHours {
  /** Business */
  Business = 'BUSINESS',
  /** Regular */
  Regular = 'REGULAR'
}

export type NurseryGuardianType = {
  __typename?: 'NurseryGuardianType';
  anyChildrenExternallyManaged?: Maybe<Scalars['Boolean']>;
  bookingRequests?: Maybe<Array<Maybe<SessionBookingRequestType>>>;
  canBookChildcare?: Maybe<Scalars['Boolean']>;
  canBookMarketplaceActivities?: Maybe<Scalars['Boolean']>;
  children?: Maybe<Array<Maybe<ChildType>>>;
  cognitoId?: Maybe<Scalars['UUID']>;
  cognitoLastAuthTime?: Maybe<Scalars['DateTime']>;
  cognitoUserPoolId?: Maybe<Scalars['String']>;
  dateJoined?: Maybe<Scalars['DateTime']>;
  fullName: Scalars['String'];
  id: Scalars['UUID'];
  marketingOptIn?: Maybe<Scalars['Boolean']>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethodType>>>;
  phoneNumber: Scalars['String'];
  status: GuardianStatus;
  stripeCustomerId?: Maybe<Scalars['String']>;
};

export type NurseryGuardiansListSummaryType = {
  __typename?: 'NurseryGuardiansListSummaryType';
  /** Total number of children in pending or approved status for the given nursery */
  childrenCount?: Maybe<Scalars['Int']>;
  /** Total number of guardians in pending or approved status for the given nursery */
  guardiansCount?: Maybe<Scalars['Int']>;
  nurseryId?: Maybe<Scalars['UUID']>;
};

export enum NurseryInstantBookingCutoffWindowHours {
  /** Business */
  Business = 'BUSINESS',
  /** Regular */
  Regular = 'REGULAR'
}

export type NurseryOrganizationType = {
  __typename?: 'NurseryOrganizationType';
  id: Scalars['UUID'];
  isManagedByExternalSystem: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
};

export type NurseryPaymentAccountCreateMutation = {
  __typename?: 'NurseryPaymentAccountCreateMutation';
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  nurseryPaymentAccount?: Maybe<NurseryPaymentAccountType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type NurseryPaymentAccountType = {
  __typename?: 'NurseryPaymentAccountType';
  paymentAccountId?: Maybe<Scalars['String']>;
  paymentAccountOnboardingUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AccountStatus>;
};

export type NurseryPriceListType = {
  __typename?: 'NurseryPriceListType';
  ageEnd: Scalars['Int'];
  ageStart: Scalars['Int'];
  amPrice: Scalars['Int'];
  fullDayPrice: Scalars['Int'];
  id: Scalars['UUID'];
  pmPrice: Scalars['Int'];
};

/** Availability for a single nursery room for multiple dates */
export type NurseryRoomAvailabilityMultiDateType = {
  __typename?: 'NurseryRoomAvailabilityMultiDateType';
  availability?: Maybe<Array<Maybe<AvailabilityOnDateType>>>;
  room?: Maybe<NurseryRoomType>;
};

export type NurseryRoomType = {
  __typename?: 'NurseryRoomType';
  /** Leave blank or set to a value greater than Age months start (must be set to enable Non-primary bookings for the nursery). */
  ageMonthsEnd?: Maybe<Scalars['Int']>;
  /** Leave blank or set to a value greater than 0 (must be set to enable Non-primary bookings for the nursery). */
  ageMonthsStart?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  externalSystemActive: Scalars['Boolean'];
  externalSystemId?: Maybe<Scalars['String']>;
  externalSystemLastUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  nursery: NurseryType;
};

/** Availability and price for a given nursery room  */
export type NurseryRoomWithAvailabilityAndPriceForDateType = {
  __typename?: 'NurseryRoomWithAvailabilityAndPriceForDateType';
  availableSessionCount?: Maybe<Scalars['Int']>;
  customSessionType?: Maybe<CustomSessionTypeModelType>;
  date?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['UUID']>;
  nursery?: Maybe<NurserySummaryType>;
  roomName?: Maybe<Scalars['String']>;
  sessionPrice?: Maybe<Scalars['Float']>;
  sessionType?: Maybe<Scalars['String']>;
};

export type NurserySummaryType = {
  __typename?: 'NurserySummaryType';
  availabilityLastSynchronised?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  isExternallyManaged?: Maybe<Scalars['Boolean']>;
  location?: Maybe<LocationType>;
  milesFromPrimary?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  showCustomSessionTimes?: Maybe<Scalars['Boolean']>;
};

export type NurseryType = {
  __typename?: 'NurseryType';
  /** This field is deprecated, please use 'location' field */
  addressLine1?: Maybe<Scalars['String']>;
  /** This field is deprecated, please use 'location' field */
  addressLine2?: Maybe<Scalars['String']>;
  /** If set to True only allow booking requests, (not instant booking) for this nursery in the Guardian Web App. */
  allowOnlyBookingRequests: Scalars['Boolean'];
  /** If set to True only full day session bookings will be allowed for this nursery in the Guardian Web App. */
  allowOnlyFullDaySessions: Scalars['Boolean'];
  availabilityLastEditedAt?: Maybe<Scalars['DateTime']>;
  availabilityLastSynchronised?: Maybe<Scalars['DateTime']>;
  /** The threshold must be between 2 and 90 days */
  bookingHoldThresholdDays: Scalars['Int'];
  /**
   *
   *         The minimum number of hours needed prior to session start for booking requests.<br/>
   *         Please note - setting a cutoff window may clash with set nursery availability.
   *
   */
  bookingRequestCutoffWindow: Scalars['Int'];
  bookingRequestCutoffWindowHours: NurseryBookingRequestCutoffWindowHours;
  /** This field is deprecated, please use 'location' field */
  city?: Maybe<Scalars['String']>;
  /** This field is deprecated, please use 'location' field */
  country?: Maybe<Scalars['String']>;
  externalSystemActive: Scalars['Boolean'];
  externalSystemId?: Maybe<Scalars['String']>;
  externalSystemLastUpdated?: Maybe<Scalars['DateTime']>;
  hubspotAccountId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /**
   *
   *         The minimum number of hours needed prior to session start for instant bookings.<br/>
   *         Please note - setting a cutoff window may clash with set nursery availability.
   *
   */
  instantBookingCutoffWindow: Scalars['Int'];
  instantBookingCutoffWindowHours: NurseryInstantBookingCutoffWindowHours;
  isBookingHoldEnabled: Scalars['Boolean'];
  /** If set to True Custom Session Bookings will be enabled for this Nursery */
  isCustomSessionBookingsEnabled: Scalars['Boolean'];
  isExternallyManaged: Scalars['Boolean'];
  /** This field is deprecated and will be removed in the near future */
  isExtracurricularActivityEnabled?: Maybe<Scalars['Boolean']>;
  /** Payments must be enabled, latitude/longitude must be set and all rooms must have valid age brackets to enable Non-primary bookings. */
  isNonPrimaryBookingEnabled: Scalars['Boolean'];
  /** You must make the parent organisation visible before you can make this nursery visible. */
  isVisible: Scalars['Boolean'];
  location?: Maybe<LocationType>;
  name: Scalars['String'];
  nurseryRooms?: Maybe<Array<Maybe<NurseryRoomType>>>;
  organization: NurseryOrganizationType;
  paymentAccount?: Maybe<NurseryPaymentAccountType>;
  paymentsEnabled: Scalars['Boolean'];
  phoneNumber: Scalars['String'];
  /** This field is deprecated, please use 'location' field */
  postCode?: Maybe<Scalars['String']>;
  priceList?: Maybe<Array<Maybe<NurseryPriceListType>>>;
  sessionTypes?: Maybe<Array<Maybe<CustomSessionTypeModelType>>>;
  /** If set to True Custom Session Times will be displayed in the UI of the Guardian and Nursery Admin apps. */
  showCustomSessionTimes: Scalars['Boolean'];
};

export type OfstedLocationAndUrnInput = {
  name: Scalars['String'];
  urn: Scalars['String'];
};

export type PaymentCardType = {
  __typename?: 'PaymentCardType';
  brand?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

/** Possible reasons a guardian is exempt from paying for a session.  */
export enum PaymentExemptionReasonEnum {
  EmergencyCareSession = 'EMERGENCY_CARE_SESSION',
  SessionInLieu = 'SESSION_IN_LIEU',
  SettleInSession = 'SETTLE_IN_SESSION',
  TaxFreeSession = 'TAX_FREE_SESSION'
}

export type PaymentMethodType = {
  __typename?: 'PaymentMethodType';
  card?: Maybe<PaymentCardType>;
  created?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};

export type PaymentOptionsInput = {
  childcareVouchers: Scalars['Boolean'];
  taxFreeCredits: Scalars['Boolean'];
};

/** Collates both Payment.StripePaymentStatus and Payment.PonchoPayStatus choice enums. */
export enum PaymentStatus {
  Canceled = 'CANCELED',
  Captured = 'CAPTURED',
  Completed = 'COMPLETED',
  InBank = 'IN_BANK',
  Processing = 'PROCESSING',
  RequiresAction = 'REQUIRES_ACTION',
  RequiresCapture = 'REQUIRES_CAPTURE',
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  Succeeded = 'SUCCEEDED'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  amount?: Maybe<Scalars['Decimal']>;
  clientSecret?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  isRefunded?: Maybe<Scalars['Boolean']>;
  paidViaCsm?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethodType>;
  processor?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  refundAmount?: Maybe<Scalars['Decimal']>;
  sessionId?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
};

export enum PebbleUseChoices {
  BookingManagementSoftware = 'BOOKING_MANAGEMENT_SOFTWARE',
  Enquiry = 'ENQUIRY',
  Marketplace = 'MARKETPLACE'
}

export type PerBookingAddonInputType = {
  addonOptionId: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type PerBookingAddonList = {
  __typename?: 'PerBookingAddonList';
  addonOption?: Maybe<AddonOptionType>;
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type PerSessionAddonInputType = {
  addonOptionId: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  selectedSessionIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

export type PerSessionAddonList = {
  __typename?: 'PerSessionAddonList';
  addonOption?: Maybe<AddonOptionType>;
  note?: Maybe<Scalars['String']>;
  selectedSessions?: Maybe<Array<Maybe<BasketActivitySessionType>>>;
};

export type PlaceCategoryType = {
  __typename?: 'PlaceCategoryType';
  category: CategoryType;
  id: Scalars['UUID'];
  noIndexNoFollow: Scalars['Boolean'];
  pageCopy?: Maybe<Scalars['String']>;
  pageHeading?: Maybe<Scalars['String']>;
  seoPageDescription?: Maybe<Scalars['String']>;
  seoPageTitle?: Maybe<Scalars['String']>;
};

export type PlaceType = {
  __typename?: 'PlaceType';
  categories?: Maybe<Array<Maybe<PlaceCategoryType>>>;
  /** The default radius in miles in which to search for activities around this place's post code. */
  defaultRadius: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  noIndexNoFollow: Scalars['Boolean'];
  pageCopy?: Maybe<Scalars['String']>;
  pageHeading?: Maybe<Scalars['String']>;
  postCode: Scalars['String'];
  seoPageDescription?: Maybe<Scalars['String']>;
  seoPageTitle?: Maybe<Scalars['String']>;
};

export type PriceListByChildType = {
  __typename?: 'PriceListByChildType';
  amPrice?: Maybe<Scalars['Float']>;
  endDate?: Maybe<Scalars['String']>;
  fullDayPrice?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  pmPrice?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['String']>;
};

export enum PricingPolicy {
  BlockFullPrice = 'BLOCK_FULL_PRICE',
  Free = 'FREE',
  PerSession = 'PER_SESSION',
  Recurring = 'RECURRING'
}

export type ProductInputType = {
  checkoutKey: CheckoutKeyEnum;
  checkoutValue: Scalars['UUID'];
  endTime: Scalars['String'];
  startTime: Scalars['String'];
  weekdays?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductType = {
  __typename?: 'ProductType';
  allBlockDates?: Maybe<Array<Maybe<DateAvailabilityType>>>;
  blockFirstSessionDate?: Maybe<Scalars['Date']>;
  blockLastSessionDate?: Maybe<Scalars['Date']>;
  checkoutKey: CheckoutKeyEnum;
  checkoutValue: Scalars['UUID'];
  checksum?: Maybe<Scalars['String']>;
  dateRange?: Maybe<Scalars['String']>;
  endTime: Scalars['String'];
  multipleSessionDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  numberOfSessionsAvailable?: Maybe<Scalars['Int']>;
  singleSessionDate?: Maybe<Scalars['Date']>;
  spotsLeft?: Maybe<Scalars['Int']>;
  startTime: Scalars['String'];
  subscriptionNextSessionDate?: Maybe<Scalars['Date']>;
  timeGroup: ActivityTimeEnum;
  weekdays?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductsByDate = {
  __typename?: 'ProductsByDate';
  date: Scalars['Date'];
  products?: Maybe<Array<Maybe<ProductType>>>;
};

export type PromotionType = {
  __typename?: 'PromotionType';
  code?: Maybe<Scalars['String']>;
  pebblePaysForPromotions?: Maybe<Scalars['Boolean']>;
};

export type ProviderOnline = {
  __typename?: 'ProviderOnline';
  items?: Maybe<Array<Maybe<ActivityCard>>>;
  totalActivities?: Maybe<Scalars['Int']>;
};

export type ProviderSearchResult = {
  __typename?: 'ProviderSearchResult';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  providers?: Maybe<Array<Maybe<ProviderSummary>>>;
  totalActivities?: Maybe<Scalars['Int']>;
  totalProviders?: Maybe<Scalars['Int']>;
};

export type ProviderSummary = {
  __typename?: 'ProviderSummary';
  allSoldOut?: Maybe<Scalars['Boolean']>;
  limitedSpots?: Maybe<Scalars['Boolean']>;
  nearestActivity?: Maybe<Scalars['Float']>;
  online?: Maybe<ProviderOnline>;
  popular?: Maybe<Scalars['Boolean']>;
  supplier?: Maybe<MarketplaceSupplierType>;
  totalActivities?: Maybe<Scalars['Int']>;
  venues?: Maybe<Array<Maybe<ProviderVenue>>>;
  weekdays?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProviderVenue = {
  __typename?: 'ProviderVenue';
  distanceInMiles?: Maybe<Scalars['Float']>;
  items?: Maybe<Array<Maybe<ActivityCard>>>;
  latitude?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  totalActivities?: Maybe<Scalars['Int']>;
};

export type PublicActivityType = {
  __typename?: 'PublicActivityType';
  activityType: ActivityTypeEnum;
  /** Enter cloudinary image IDs as a comma separated list */
  additionalImageIds?: Maybe<Array<Scalars['String']>>;
  /** Set to a value greater than Age months start. */
  ageMonthsEnd: Scalars['Int'];
  /** Set to a value greater than or equal to 0. */
  ageMonthsStart: Scalars['Int'];
  ageRange: Scalars['String'];
  allowBlockBookings: Scalars['Boolean'];
  allowIndividualBookings: Scalars['Boolean'];
  blockSubtype?: Maybe<Scalars['String']>;
  /** Select between Enquire or Instant or Subscription booking */
  bookingType: ActivityBookingType;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  /** Will be used for enquiries about this activity */
  email: Scalars['String'];
  enquiryBookingUrl?: Maybe<Scalars['String']>;
  /** Price in pence to be displayed on activity cards for activity of booking_type enquire */
  enquiryPrice: Scalars['Int'];
  expressEnquiry: Scalars['Boolean'];
  guardianToProvide?: Maybe<Scalars['String']>;
  hideEndTimes: Scalars['Boolean'];
  id: Scalars['UUID'];
  isOnline: Scalars['Boolean'];
  location?: Maybe<LocationTypeWithResolvedCoordinates>;
  locationAdditionalInfo?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** The Ofsted Unique Reference Number for the Supplier Location of this Activity, required for Poncho Pay */
  ofstedUrn?: Maybe<Scalars['String']>;
  /** Public extra information field for online activities */
  onlinePublicInfo?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ponchoPayAccepted?: Maybe<Scalars['Boolean']>;
  seoPageDescription: Scalars['String'];
  seoPageTitle: Scalars['String'];
  showEmail: Scalars['Boolean'];
  showEnquiryBookingUrl: Scalars['Boolean'];
  showPhoneNumber: Scalars['Boolean'];
  /** Unique descriptive reference for an activity based on underlying activity fields */
  slug?: Maybe<Scalars['String']>;
  /** Number of times slug field has changed due to changes to underlying activity fields */
  slugChangeCount: Scalars['Int'];
  socialProof?: Maybe<SocialProof>;
  status: ActivityStatus;
  subscriptionBillingFrequency?: Maybe<ActivitySubscriptionBillingFrequency>;
  subscriptionInfo?: Maybe<Scalars['String']>;
  subscriptionOffDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
  subscriptionStart?: Maybe<Scalars['DateTime']>;
  /** Subscription trial price in pence */
  subscriptionTrialPrice?: Maybe<Scalars['Int']>;
  /** Set to a value between 0 and 3 */
  subscriptionTrialSessionCount?: Maybe<Scalars['Int']>;
  subscriptionTrialType?: Maybe<ActivitySubscriptionTrialType>;
  supplier: MarketplaceSupplierType;
  supplierToProvide?: Maybe<Scalars['String']>;
  /** Term template used for activity blocks and sessions */
  term?: Maybe<TermType>;
};

export type Queries = {
  __typename?: 'Queries';
  activitiesBySupplier?: Maybe<SupplierActivityResultType>;
  activityBookingByBasketId?: Maybe<AnonymisedActivityBookingSchemaType>;
  activityBookingByCheckoutSessionId?: Maybe<AnonymisedActivityBookingSchemaType>;
  activityBookingForSupplier?: Maybe<ActivityBookingSchemaType>;
  activityBookingSessionsForSupplier?: Maybe<ActivityBookingTicketSessionsResultType>;
  activityBookingsByIds?: Maybe<Array<Maybe<ActivityBookingSchemaType>>>;
  activityBookingsBySupplierSummary?: Maybe<ActivityBookingsBySupplierSummaryType>;
  allBookingsForGuardian?: Maybe<Array<Maybe<AllBookingsForGuardianType>>>;
  attendeeList?: Maybe<SupplierAttendeeListType>;
  availabilityForGuardian?: Maybe<AvailabilityMultiRoomMultiDateType>;
  availabilityForGuardianAtNonPrimary?: Maybe<AvailabilityAndPricesMultiRoomSingleDateType>;
  availabilityForNurseryAdmin?: Maybe<AvailabilityForNurseryType>;
  availabilityForNurseryAdminSummary?: Maybe<AvailabilityForNurseryAdminSummaryType>;
  bookingRequestPrice?: Maybe<SessionBookingPriceType>;
  bookings?: Maybe<Array<Maybe<SessionBookingRequestType>>>;
  bookingsByIds?: Maybe<Array<Maybe<SessionBookingRequestType>>>;
  bookingsByNursery?: Maybe<Array<Maybe<SessionBookingRequestType>>>;
  bookingsByNurserySummary?: Maybe<SessionBookingByNurserySummaryType>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  category?: Maybe<CategoryType>;
  checkSessionCapacity?: Maybe<ActivitySessionType>;
  childPriceListById?: Maybe<ChildType>;
  customSessionTypeById?: Maybe<CustomSessionTypesForChildType>;
  customSessionTypesByChild?: Maybe<Array<Maybe<CustomSessionTypesForChildType>>>;
  financeReportFiltersAndTotals?: Maybe<ActivityTransactionFiltersAndTotalsType>;
  getAdditionalInfoForCapture?: Maybe<AdditionalInfoType>;
  getAttendeeBookingTicketSessions?: Maybe<Array<Maybe<ActivityBookingTicketSessionType>>>;
  getBasket?: Maybe<BasketType>;
  getCheckoutSessionMetadata?: Maybe<CheckoutSessionMetadataType>;
  getRefundReasons?: Maybe<Array<Maybe<RefundReasonEnum>>>;
  getRefundReceipt?: Maybe<GetRefundReceiptType>;
  guardian?: Maybe<GuardianType>;
  guardianById?: Maybe<NurseryGuardianType>;
  guardiansByNursery?: Maybe<Array<Maybe<NurseryGuardianType>>>;
  guardiansByNurserySummary?: Maybe<NurseryGuardiansListSummaryType>;
  marketplaceActivities?: Maybe<ActivitySearchResult>;
  marketplaceActivity?: Maybe<ActivityDetailsType>;
  marketplaceActivityBySlug?: Maybe<ActivityDetailsType>;
  marketplaceActivityForGuardian?: Maybe<ActivityDetailsType>;
  marketplaceActivitySitemapInfo?: Maybe<SitemapInfoType>;
  marketplaceFranchise?: Maybe<MarketplaceFranchiseType>;
  marketplaceFranchiseBySlug?: Maybe<MarketplaceFranchiseType>;
  marketplaceProviders?: Maybe<ProviderSearchResult>;
  marketplaceSupplier?: Maybe<MarketplaceSupplierType>;
  marketplaceSupplierBySlug?: Maybe<MarketplaceSupplierType>;
  marketplaceSupplierMemberships?: Maybe<Array<Maybe<SupplierAdminMembershipType>>>;
  marketplaceSuppliers?: Maybe<Array<Maybe<MarketplaceSupplierType>>>;
  nurseries?: Maybe<Array<Maybe<NurseryType>>>;
  nurseryAdmin?: Maybe<MeNurseryPortalQueryUnionTypes>;
  nurseryById?: Maybe<NurseryType>;
  nurseryOrganizationByNurseryId?: Maybe<NurseryOrganizationType>;
  nurseryOrganizationsForGuardians?: Maybe<Array<Maybe<NurseryOrganizationType>>>;
  placeByName?: Maybe<PlaceType>;
  places?: Maybe<Array<Maybe<PlaceType>>>;
  promotionForGuardians?: Maybe<BookingPromotionType>;
  promotionForGuests?: Maybe<BookingPromotionType>;
  questionBank?: Maybe<Array<Maybe<Question2Type>>>;
  registerSessions?: Maybe<Array<Maybe<ActivityRegisterSessionType>>>;
  sessionBookingByCheckoutSessionId?: Maybe<SessionBookingRequestType>;
  sessionBookingsByNurserySummary?: Maybe<SessionBookingByNurserySummaryType>;
  subscriptionActivityBookingsForSupplier?: Maybe<SubscriptionActivitySchedulesResultType>;
  supplierAdmin?: Maybe<SupplierAdminType>;
  supplierAllPaidActivities?: Maybe<Array<Maybe<MarketplaceActivityType>>>;
  supplierClassCapacity?: Maybe<SupplierCapacityType>;
  supplierCustomersFromBookings?: Maybe<Array<Maybe<CustomerEmailsFromPastBookingsType>>>;
  supplierFutureActivities?: Maybe<Array<Maybe<ActivityDetailsForMoveType>>>;
  supplierLocations?: Maybe<SupplierLocationsType>;
  supplierOnboarding?: Maybe<SupplierOnboardingType>;
  supplierUpcomingClasses?: Maybe<SupplierUpcomingType>;
  termsBySupplier?: Maybe<Array<Maybe<TermType>>>;
  waitlistByActivity?: Maybe<WaitListSchemaResultType>;
};


export type QueriesActivitiesBySupplierArgs = {
  activityId?: Maybe<Scalars['UUID']>;
  dateFilter?: Maybe<TermDateFilterEnum>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  supplierId: Scalars['UUID'];
  venue?: Maybe<Scalars['String']>;
};


export type QueriesActivityBookingByBasketIdArgs = {
  basketId: Scalars['UUID'];
};


export type QueriesActivityBookingByCheckoutSessionIdArgs = {
  checkoutSessionId: Scalars['String'];
};


export type QueriesActivityBookingForSupplierArgs = {
  bookingId?: Maybe<Scalars['UUID']>;
};


export type QueriesActivityBookingSessionsForSupplierArgs = {
  activityId?: Maybe<Scalars['UUID']>;
  activityName?: Maybe<Scalars['String']>;
  datetimeEnd?: Maybe<Scalars['DateTime']>;
  datetimeStart?: Maybe<Scalars['DateTime']>;
  freeTextSearch?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<Scalars['String']>;
  supplierId: Scalars['UUID'];
  times?: Maybe<Array<Maybe<Scalars['String']>>>;
  venue?: Maybe<Scalars['String']>;
};


export type QueriesActivityBookingsByIdsArgs = {
  activityBookingIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type QueriesActivityBookingsBySupplierSummaryArgs = {
  supplierId: Scalars['UUID'];
};


export type QueriesAllBookingsForGuardianArgs = {
  bookingFilter: BookingType;
  startDate?: Maybe<Scalars['Date']>;
};


export type QueriesAttendeeListArgs = {
  input?: Maybe<SupplierAttendeeInputType>;
};


export type QueriesAvailabilityForGuardianArgs = {
  childId: Scalars['UUID'];
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};


export type QueriesAvailabilityForGuardianAtNonPrimaryArgs = {
  childId: Scalars['UUID'];
  date: Scalars['Date'];
  nurseryId: Scalars['UUID'];
  sessionType: BookingSessionTypeEnum;
};


export type QueriesAvailabilityForNurseryAdminArgs = {
  endDate?: Maybe<Scalars['Date']>;
  nurseryId: Scalars['UUID'];
  startDate?: Maybe<Scalars['Date']>;
};


export type QueriesAvailabilityForNurseryAdminSummaryArgs = {
  nurseryId: Scalars['UUID'];
};


export type QueriesBookingRequestPriceArgs = {
  child: Scalars['UUID'];
  clientSecret?: Maybe<Scalars['Boolean']>;
  customSessionType?: Maybe<Scalars['UUID']>;
  date: Scalars['Date'];
  promotion?: Maybe<Scalars['UUID']>;
  room?: Maybe<Scalars['UUID']>;
  sessionType?: Maybe<BookingSessionTypeEnum>;
};


export type QueriesBookingsArgs = {
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
};


export type QueriesBookingsByIdsArgs = {
  bookingIds: Array<Maybe<Scalars['UUID']>>;
};


export type QueriesBookingsByNurseryArgs = {
  endDate?: Maybe<Scalars['Date']>;
  filterAction?: Maybe<BookingFilterActionEnum>;
  nurseryId: Scalars['UUID'];
  roomId?: Maybe<Scalars['UUID']>;
  sortBy?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};


export type QueriesBookingsByNurserySummaryArgs = {
  nurseryId: Scalars['UUID'];
};


export type QueriesCategoryArgs = {
  categoryId: Scalars['UUID'];
};


export type QueriesCheckSessionCapacityArgs = {
  sessionId: Scalars['UUID'];
};


export type QueriesChildPriceListByIdArgs = {
  childId: Scalars['UUID'];
};


export type QueriesCustomSessionTypeByIdArgs = {
  child: Scalars['UUID'];
  customSessionType: Scalars['UUID'];
};


export type QueriesCustomSessionTypesByChildArgs = {
  child: Scalars['UUID'];
  nursery: Scalars['UUID'];
};


export type QueriesFinanceReportFiltersAndTotalsArgs = {
  datetimeEnd?: Maybe<Scalars['DateTime']>;
  datetimeStart?: Maybe<Scalars['DateTime']>;
  supplierId: Scalars['UUID'];
};


export type QueriesGetAdditionalInfoForCaptureArgs = {
  activityBooking: Scalars['UUID'];
};


export type QueriesGetAttendeeBookingTicketSessionsArgs = {
  bookingSessionId: Scalars['UUID'];
  supplierId: Scalars['UUID'];
};


export type QueriesGetBasketArgs = {
  id: Scalars['UUID'];
};


export type QueriesGetCheckoutSessionMetadataArgs = {
  checkoutSessionId: Scalars['String'];
};


export type QueriesGetRefundReasonsArgs = {
  supplierId: Scalars['UUID'];
};


export type QueriesGetRefundReceiptArgs = {
  bookingSessionIds: Array<Maybe<Scalars['UUID']>>;
  refundAmount?: Maybe<Scalars['Int']>;
  supplierId: Scalars['UUID'];
};


export type QueriesGuardianByIdArgs = {
  guardianId: Scalars['UUID'];
  nurseryId?: Maybe<Scalars['UUID']>;
};


export type QueriesGuardiansByNurseryArgs = {
  nurseryId: Scalars['UUID'];
};


export type QueriesGuardiansByNurserySummaryArgs = {
  nurseryId: Scalars['UUID'];
};


export type QueriesMarketplaceActivitiesArgs = {
  ageEnd?: Maybe<Scalars['Int']>;
  ageStart?: Maybe<Scalars['Int']>;
  bookingType?: Maybe<Array<Maybe<BookingTypesEnum>>>;
  bounds?: Maybe<GeoBoundsInput>;
  categories?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  dayOfTheWeek?: Maybe<Array<Maybe<ActivityDayOfWeekFilterEnum>>>;
  distance?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  postcode?: Maybe<Scalars['String']>;
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  startDate?: Maybe<Scalars['Date']>;
  supplier?: Maybe<Scalars['UUID']>;
  supplierSlug?: Maybe<Scalars['String']>;
  suppliers?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  text?: Maybe<Scalars['String']>;
  time?: Maybe<ActivityTimeEnum>;
};


export type QueriesMarketplaceActivityArgs = {
  activityId: Scalars['UUID'];
  date?: Maybe<Scalars['Date']>;
};


export type QueriesMarketplaceActivityBySlugArgs = {
  activitySlug: Scalars['String'];
};


export type QueriesMarketplaceActivityForGuardianArgs = {
  activityId: Scalars['UUID'];
  date?: Maybe<Scalars['Date']>;
};


export type QueriesMarketplaceFranchiseArgs = {
  franchiseId: Scalars['UUID'];
};


export type QueriesMarketplaceFranchiseBySlugArgs = {
  franchiseSlug: Scalars['String'];
};


export type QueriesMarketplaceProvidersArgs = {
  ageEnd?: Maybe<Scalars['Int']>;
  ageStart?: Maybe<Scalars['Int']>;
  bookingType?: Maybe<Array<Maybe<BookingTypesEnum>>>;
  bounds?: Maybe<GeoBoundsInput>;
  categories?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  dayOfTheWeek?: Maybe<Array<Maybe<ActivityDayOfWeekFilterEnum>>>;
  distance?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['Date']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  longitude?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  postcode?: Maybe<Scalars['String']>;
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  startDate?: Maybe<Scalars['Date']>;
  supplier?: Maybe<Scalars['UUID']>;
  supplierSlug?: Maybe<Scalars['String']>;
  suppliers?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  text?: Maybe<Scalars['String']>;
  time?: Maybe<ActivityTimeEnum>;
};


export type QueriesMarketplaceSupplierArgs = {
  supplierId: Scalars['UUID'];
};


export type QueriesMarketplaceSupplierBySlugArgs = {
  supplierSlug: Scalars['String'];
};


export type QueriesMarketplaceSupplierMembershipsArgs = {
  adminAccess?: Maybe<Array<Maybe<SupplierAdminAccessEnum>>>;
  supplierId: Scalars['UUID'];
};


export type QueriesMarketplaceSuppliersArgs = {
  searchTerm?: Maybe<Scalars['String']>;
};


export type QueriesNurseriesArgs = {
  organizationId?: Maybe<Scalars['UUID']>;
  schoolId?: Maybe<Scalars['UUID']>;
  showAll?: Maybe<Scalars['Boolean']>;
};


export type QueriesNurseryByIdArgs = {
  nurseryId: Scalars['UUID'];
};


export type QueriesNurseryOrganizationByNurseryIdArgs = {
  nurseryId: Scalars['UUID'];
};


export type QueriesNurseryOrganizationsForGuardiansArgs = {
  showAll?: Maybe<Scalars['Boolean']>;
};


export type QueriesPlaceByNameArgs = {
  name: Scalars['String'];
};


export type QueriesPromotionForGuardiansArgs = {
  amount: Scalars['Int'];
  bookingDate: Scalars['Date'];
  bookingType: BookingTypeEnum;
  categories?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  code: Scalars['String'];
  isSingleSession?: Maybe<Scalars['Boolean']>;
  nursery?: Maybe<Scalars['UUID']>;
  supplier?: Maybe<Scalars['UUID']>;
  ticketsNumber?: Maybe<Scalars['Int']>;
};


export type QueriesPromotionForGuestsArgs = {
  amount: Scalars['Int'];
  bookingDate: Scalars['Date'];
  categories?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  code: Scalars['String'];
  isSingleSession?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
  supplier?: Maybe<Scalars['UUID']>;
  ticketsNumber?: Maybe<Scalars['Int']>;
};


export type QueriesQuestionBankArgs = {
  defaultOnly?: Maybe<Scalars['Boolean']>;
  supplierId: Scalars['UUID'];
};


export type QueriesRegisterSessionsArgs = {
  activityId?: Maybe<Scalars['UUID']>;
  blockId?: Maybe<Scalars['UUID']>;
  datetimeEnd?: Maybe<Scalars['DateTime']>;
  datetimeStart?: Maybe<Scalars['DateTime']>;
  scheduleId?: Maybe<Scalars['UUID']>;
  sessionId?: Maybe<Scalars['UUID']>;
  showBooked?: Maybe<Scalars['Boolean']>;
  showUnbooked?: Maybe<Scalars['Boolean']>;
  supplierId: Scalars['UUID'];
};


export type QueriesSessionBookingByCheckoutSessionIdArgs = {
  checkoutSessionId: Scalars['String'];
};


export type QueriesSessionBookingsByNurserySummaryArgs = {
  nurseryId: Scalars['UUID'];
};


export type QueriesSubscriptionActivityBookingsForSupplierArgs = {
  activityId?: Maybe<Scalars['UUID']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  supplierId: Scalars['UUID'];
  times?: Maybe<Array<Maybe<Scalars['String']>>>;
  venue?: Maybe<Scalars['String']>;
  weekdays?: Maybe<Array<Maybe<Scalars['Int']>>>;
};


export type QueriesSupplierAllPaidActivitiesArgs = {
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  supplierId: Scalars['UUID'];
};


export type QueriesSupplierClassCapacityArgs = {
  supplierId: Scalars['UUID'];
};


export type QueriesSupplierCustomersFromBookingsArgs = {
  activityIds: Array<Maybe<Scalars['UUID']>>;
  supplierId: Scalars['UUID'];
};


export type QueriesSupplierFutureActivitiesArgs = {
  activityId?: Maybe<Scalars['UUID']>;
  searchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  supplierId: Scalars['UUID'];
};


export type QueriesSupplierLocationsArgs = {
  supplierId: Scalars['UUID'];
};


export type QueriesSupplierOnboardingArgs = {
  supplierId: Scalars['UUID'];
};


export type QueriesSupplierUpcomingClassesArgs = {
  forDate?: Maybe<Scalars['Date']>;
  supplierId: Scalars['UUID'];
};


export type QueriesTermsBySupplierArgs = {
  dateFilter?: Maybe<TermDateFilterEnum>;
  supplierId: Scalars['UUID'];
};


export type QueriesWaitlistByActivityArgs = {
  activityId: Scalars['UUID'];
  dateEnd?: Maybe<Scalars['DateTime']>;
  dateStart?: Maybe<Scalars['DateTime']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  timeFilter?: Maybe<Array<Maybe<Scalars['String']>>>;
  weekdaysFilter?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Question2Type = {
  __typename?: 'Question2Type';
  id: Scalars['UUID'];
  isDefault: Scalars['Boolean'];
  isPerAttendee: Scalars['Boolean'];
  shortTitle: Scalars['String'];
  title: Scalars['String'];
  type: QuestionType;
};

export type QuestionAnswerInputType = {
  attendeeAnswers?: Maybe<Array<Maybe<AttendeeAnswerInputType>>>;
  bookerAnswer?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type QuestionAnswerType = {
  __typename?: 'QuestionAnswerType';
  attendeeAnswers?: Maybe<Array<Maybe<AttendeeAnswerType>>>;
  bookerAnswer?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  previousBookerAnswer?: Maybe<Scalars['String']>;
  question: Question2Type;
  requiredBeforeCheckout: Scalars['Boolean'];
};

export enum QuestionType {
  /** Checkbox */
  Checkbox = 'CHECKBOX',
  /** Text input */
  TextInput = 'TEXT_INPUT',
  /** Yes or No */
  YesNo = 'YES_NO',
  /** Yes or No, text input if yes */
  YesNoInput = 'YES_NO_INPUT'
}

export enum Reason {
  CustomerRequested = 'CUSTOMER_REQUESTED',
  FullActivityCancelled = 'FULL_ACTIVITY_CANCELLED',
  Other = 'OTHER',
  SessionCancelled = 'SESSION_CANCELLED'
}

export enum RefundReason {
  /** Customer requested */
  CustomerRequested = 'CUSTOMER_REQUESTED',
  /** Full activity cancelled */
  FullActivityCancelled = 'FULL_ACTIVITY_CANCELLED',
  /** Other */
  Other = 'OTHER',
  /** Session cancelled */
  SessionCancelled = 'SESSION_CANCELLED'
}

export enum RefundReasonEnum {
  CustomerRequested = 'CUSTOMER_REQUESTED',
  FullActivityCancelled = 'FULL_ACTIVITY_CANCELLED',
  Other = 'OTHER',
  SessionCancelled = 'SESSION_CANCELLED'
}

export enum RefundStatus {
  /** Incomplete */
  Incomplete = 'INCOMPLETE',
  /** Successful */
  Successful = 'SUCCESSFUL'
}

export type RefundType = {
  __typename?: 'RefundType';
  amount: Scalars['Int'];
  booking?: Maybe<ActivityBookingSchemaType>;
  bookingSessions: Array<ActivityBookingTicketSessionType>;
  id: Scalars['UUID'];
  reason?: Maybe<RefundReason>;
  reasonDetails?: Maybe<Scalars['String']>;
  status: RefundStatus;
  stripeRefundId?: Maybe<Scalars['String']>;
  stripeTransferReversalId?: Maybe<Scalars['String']>;
  transferReversedAmount?: Maybe<Scalars['Int']>;
};

/** Summary of session bookings for a specific nursery.  */
export type SessionBookingByNurserySummaryType = {
  __typename?: 'SessionBookingByNurserySummaryType';
  nurseryId?: Maybe<Scalars['UUID']>;
  /** Total number of confirmed session bookings for all time. */
  totalConfirmedBookingsAllTime?: Maybe<Scalars['Int']>;
  /** Total number of confirmed session bookings made this calendar month. */
  totalConfirmedBookingsThisMonth?: Maybe<Scalars['Int']>;
  /** Total number of pending session booking requests from today onwards. */
  totalPendingRequestsUpcoming?: Maybe<Scalars['Int']>;
  /** Total number of pending session booking requests from today onwards that were created >= 5 hours ago. */
  totalPendingRequestsUpcomingUrgent?: Maybe<Scalars['Int']>;
};

export enum SessionBookingCancellationReason {
  /** Illness */
  Illness = 'ILLNESS',
  /** No longer needed */
  NoLongerNeeded = 'NO_LONGER_NEEDED',
  /** Other */
  Other = 'OTHER'
}

/**
 * ### Delete All Bookings For Guardian
 * Given a Guardian ID, tries to delete ALL Bookings for the relevant Guardian.
 *
 * If Guardian.is_test_guardian == True, allow the operation, else raise an error.
 *
 * This mutation only exists for automated testing of the front-end, so that these tests can
 * clean up after themselves and not pollute our database with unnecessary test bookings.
 *
 * Relies on feature flag `ALLOW_TEST_BOOKING_DELETIONS`.
 *
 * ### Errors
 * `GUARDIAN_DOES_NOT_EXIST`: Guardian ID does not exist in our system.
 *
 * `UNAUTHORISED_NURSERY_ADMIN_ACTION`: When the Guardian with the ID passed in
 * is NOT a test guardian. Or the feature flag `ALLOW_TEST_BOOKING_DELETIONS` is not set to `ON`.
 */
export type SessionBookingDeleteMutation = {
  __typename?: 'SessionBookingDeleteMutation';
  bookingsDeleted?: Maybe<SessionBookingDeleteType>;
};

export type SessionBookingDeleteType = {
  __typename?: 'SessionBookingDeleteType';
  deletedCount?: Maybe<Scalars['Int']>;
};

export enum SessionBookingPaymentExemptionReason {
  /** Emergency care session */
  EmergencyCareSession = 'EMERGENCY_CARE_SESSION',
  /** Day in lieu */
  SessionInLieu = 'SESSION_IN_LIEU',
  /** Settle-in session */
  SettleInSession = 'SETTLE_IN_SESSION',
  /** Paid from tax-free account */
  TaxFreeSession = 'TAX_FREE_SESSION'
}

export type SessionBookingPriceType = {
  __typename?: 'SessionBookingPriceType';
  amount?: Maybe<Scalars['Decimal']>;
  clientSecret?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
};

export enum SessionBookingRejectionReason {
  /** Child-to-staff ratio */
  ChildStaffRatio = 'CHILD_STAFF_RATIO',
  /** Guardian is late on payments */
  LateOnPayments = 'LATE_ON_PAYMENTS',
  /** Other */
  Other = 'OTHER',
  /** Room is at capacity */
  RoomAtCapacity = 'ROOM_AT_CAPACITY',
  /** Staff absence */
  StaffAbsence = 'STAFF_ABSENCE'
}

/** A booking request for a child in a specific nursery session. */
export type SessionBookingRequestType = {
  __typename?: 'SessionBookingRequestType';
  additionalNotes?: Maybe<Scalars['String']>;
  cancellationDetails?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<SessionBookingCancellationReason>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  checkoutSessionId?: Maybe<Scalars['String']>;
  child: ChildType;
  createdAt: Scalars['DateTime'];
  customSessionType?: Maybe<CustomSessionTypeModelType>;
  date: Scalars['Date'];
  discount?: Maybe<Scalars['Decimal']>;
  externalSystemId?: Maybe<Scalars['String']>;
  finalAmount?: Maybe<Scalars['Decimal']>;
  id: Scalars['UUID'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  isRefunded?: Maybe<Scalars['Boolean']>;
  nursery: NurseryType;
  originalAmount?: Maybe<Scalars['Decimal']>;
  payment?: Maybe<PaymentType>;
  paymentExemptionReason?: Maybe<SessionBookingPaymentExemptionReason>;
  paymentMethod?: Maybe<PaymentMethodType>;
  promotion?: Maybe<PromotionType>;
  rejectedAt?: Maybe<Scalars['DateTime']>;
  rejectionDetails?: Maybe<Scalars['String']>;
  rejectionReason?: Maybe<SessionBookingRejectionReason>;
  room?: Maybe<NurseryRoomType>;
  sessionType?: Maybe<SessionBookingSessionType>;
  status: SessionBookingStatus;
  type: SessionBookingType;
};

export enum SessionBookingSessionType {
  /** Morning */
  Am = 'AM',
  /** Full Day */
  Full = 'FULL',
  /** None */
  None = 'NONE',
  /** Afternoon */
  Pm = 'PM'
}

export enum SessionBookingStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Moved */
  Moved = 'MOVED',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** Pending */
  Pending = 'PENDING',
  /** Rejected */
  Rejected = 'REJECTED'
}

export type SessionBookingStripeCheckoutType = {
  __typename?: 'SessionBookingStripeCheckoutType';
  checkoutSessionId: Scalars['String'];
  url: Scalars['String'];
};

export enum SessionBookingType {
  /** Instant */
  Instant = 'INSTANT',
  /** Request */
  Request = 'REQUEST'
}

export enum SessionType {
  Am = 'AM',
  Full = 'FULL',
  None = 'NONE',
  Pm = 'PM'
}

export type SitemapInfoType = {
  __typename?: 'SitemapInfoType';
  numberOfPages: Scalars['Int'];
  pageSize: Scalars['Int'];
  totalEntries: Scalars['Int'];
};

export type SocialProof = {
  __typename?: 'SocialProof';
  justAdded?: Maybe<Scalars['Boolean']>;
  limitedSpots?: Maybe<Scalars['Boolean']>;
  popular?: Maybe<Scalars['Boolean']>;
};

export type StartEndTimeType = {
  __typename?: 'StartEndTimeType';
  endTime?: Maybe<Scalars['Time']>;
  startTime?: Maybe<Scalars['Time']>;
};

export enum Status {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Moved = 'MOVED',
  OnHold = 'ON_HOLD',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum StatusEnum {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

/**
 * ###
 * Creates a session booking request for a child in a specific nursery time slot.
 *
 * Instant bookings are created if;
 * - the child's status is APPROVED
 * - the child's 'instant_book' field is set to True
 * - the nursery's 'allow_only_booking_requests' field is set to False
 * - AND there is availability for the room specified (or if not specified, the child's primary room).
 *
 * We trigger the sending of an email to the nursery with details of newly created booking.
 *
 * Optionally accepts a room, which can be a room from another nursery in
 * the same organisation as the child's primary nursery.
 *
 * ### Payment required?
 * If a payment is required we raise an error here of type PAID_BOOKING_NOT_ALLOWED_HERE,
 * as the InitiatePaidSessionBookingMutation mutation should be used instead of this mutation.
 *
 * We determine whether payment is required or not by the `payments_enabled` field of the Nursery
 * that is related to the `room` parameter & the `paymentExepmtionReason` value as well as the `amount`
 * calculated after the application of any valid promotion redeemed by the guardian.
 * 100% discounts are possible, in this case no payment would be taken even if the nursery has payments
 * enabled and the booking is not exempt.
 *
 * #### Non-paid bookings
 * If instant, booking is confirmed here, if request booking status is left at PENDING,
 * and the booking then may be approved or rejected later by a NurseryAdmin in the NAWA.
 *
 * #### Paid-for booking
 * - If `setupIntentId` is passed this is retrieved from Stripe.
 *     - if setup intent 'succeeded' the payment method associated to this is used and set as Guardian's default
 *     - else the setup intent is cancelled and Guardian's default payment method is used
 *
 * - If `setupIntentId` is not passed.
 *     - Guardian's default payment method is used
 *
 * ##### Instant
 * A payment intent is created and confirmed immediately using the appropriate payment method.
 *
 * ##### Request
 * We will store the selected payment method on the booking request so that it can be used to take payment later
 * if the request is approved by a NurseryAdmin.
 *
 * ### Previous booking cancellations
 * If `bookingToCancel` is provided and this is a non-primary booking and there is a match for a similar booking for
 * the same child and date - the booking with the provided ID is cancelled
 *
 * ### External system integration (NurseryCare)
 * If the booking is for a room in a nursery of the relevant organization (Busy Bees), then we will attempt to
 * create a booking in an external system as well. On success this returns updated availability data for our system.
 *
 * ### Force request
 * If `forceRequest` parameter is supplied as True we will create a request booking instead of an instant booking.
 *
 * ### Errors
 * `BOOKING_ALREADY_EXISTS`: When another similar or overlapping booking exists.
 *
 * `CHILD_DOES_NOT_EXIST`: Child identifier does not match a child in our system.
 *
 * `UNAUTHORISED_ACTION`: Guardian's status is `REJECTED`,
 * or child's status is `UNRECOGNIZED` or `DEACTIVATED`.
 *
 * `NURSERY_DOES_NOT_EXIST`: Nursery identifier does not match a nursery in our system.
 *
 * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
 *
 * `ORGANIZATION_DIFFERS_FROM_PRIMARY`: SessionBooking is for a non-primary nursery room but the
 * organization of the requested room's nursery differs from that of the childs primary nursery.
 *
 * `NON_PRIMARY_BOOKINGS_DISABLED`: SessionBooking is for a non-primary nursery room in the same
 * organization, but the nursery the room belongs to has not enabled non-primary bookings.
 *
 * `BOOKING_WITHIN_CUTOFF_PERIOD`: SessionBooking request made for a session starting within the
 * defined cutoff period of the nursery. Period can be specified in either regular or business
 * hours.
 *
 * `BOTH_SESSION_TYPE_AND_CUSTOM_SESSION_TYPE_PROVIDED`: Both SessionType and CustomSessionType passed
 * as parameters, we can only accept one of these.
 *
 * `SESSION_TYPE_NOT_PROVIDED`: When nursery.is_custom_session_bookings_enabled is False,
 * SessionType must be provided.
 *
 * `CUSTOM_SESSION_TYPE_NOT_PROVIDED`: When nursery.is_custom_session_bookings_enabled is True,
 * CustomSessionType must be provided.
 *
 * `NO_PAYMENT_METHOD_FOUND`: When this mutation cannot determine a payment method for a paid-for booking.
 *
 * `EXTERNAL_SESSION_BOOKING_ERROR`: Error creating session booking in external booking system API.
 *
 * `EXTERNAL_RESOURCE_NOT_FOUND`: Call to external booking system returned a 404, either child or room not recognised.
 *
 * `INVALID_EXTERNAL_DATA_SESSION_BOOKING_CREATE`: Error encountered during attempt to save returned data
 * from external booking system (NurseryCare).
 *
 * `PAYMENT_NOT_CREATED`: When error creating a new payment intent for a paid-for instant booking.
 *
 * `PAYMENT_NOT_MODIFIED`: When error updating the payment intent metadata with the booking_id.
 *
 * `PAYMENT_NOT_CAPTURED`: When there is an error capturing the payment intent for a paid-for instant booking.
 */
export type SubmitSessionBookingMutation = {
  __typename?: 'SubmitSessionBookingMutation';
  bookingRequest?: Maybe<SessionBookingRequestType>;
};

export type SubscriptionActivityFiltersType = {
  __typename?: 'SubscriptionActivityFiltersType';
  activities?: Maybe<Array<Maybe<ActivityBookingActivityFilterType>>>;
  times?: Maybe<Array<Maybe<ActivityBookingTimesFilterType>>>;
  venues?: Maybe<Array<Maybe<ActivityBookingVenueFilterType>>>;
  weekdays?: Maybe<Array<Maybe<ActivityBookingTimesFilterType>>>;
};

export type SubscriptionActivityResultType = {
  __typename?: 'SubscriptionActivityResultType';
  activity: PublicActivityType;
  activityId?: Maybe<Scalars['UUID']>;
  dayOfTheWeek?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  location?: Maybe<LocationType>;
  name?: Maybe<Scalars['String']>;
  scheduleId?: Maybe<Scalars['UUID']>;
  startTime?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<SubscriptionBookingTicketType>>>;
};

export type SubscriptionActivitySchedulesResultType = {
  __typename?: 'SubscriptionActivitySchedulesResultType';
  filters?: Maybe<SubscriptionActivityFiltersType>;
  subscriptionActivities?: Maybe<Array<Maybe<SubscriptionActivityResultType>>>;
  supplierId: Scalars['UUID'];
  total: Scalars['Int'];
};

/** Represent the object type of a subscription cancellation. */
export type SubscriptionBookingCancellationType = {
  __typename?: 'SubscriptionBookingCancellationType';
  id: Scalars['UUID'];
  status: ActivityBookingStatus;
};

export type SubscriptionBookingInvoiceType = {
  __typename?: 'SubscriptionBookingInvoiceType';
  attemptCount?: Maybe<Scalars['Int']>;
  booking: ActivityBookingByDateRangeType;
  createdAt: Scalars['DateTime'];
  /** Amount in pence paid by customer to Pebble. */
  paymentAmount?: Maybe<Scalars['Int']>;
  /** Number of automated payment attempts made for the Stripe invoice. */
  paymentAttemptCount: Scalars['Int'];
  paymentDate?: Maybe<Scalars['DateTime']>;
  paymentStatus?: Maybe<ActivityBookingInvoiceEnum>;
  status: ActivityBookingInvoiceStatus;
  stripeInvoiceId?: Maybe<Scalars['String']>;
};

export type SubscriptionBookingTicketSessionType = {
  __typename?: 'SubscriptionBookingTicketSessionType';
  bookingTicket: SubscriptionBookingTicketType;
  firstSessionDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  isFreeTrialSession?: Maybe<Scalars['Boolean']>;
  isPaidTrialSession?: Maybe<Scalars['Boolean']>;
  isTaster?: Maybe<Scalars['Boolean']>;
  sessionEnd?: Maybe<Scalars['DateTime']>;
  sessionStart?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionBookingTicketType = {
  __typename?: 'SubscriptionBookingTicketType';
  booking: ActivityBookingByDateRangeType;
  cancellationDetails?: Maybe<Scalars['String']>;
  cancellationReason?: Maybe<ActivityBookingTicketCancellationReason>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  child?: Maybe<ChildType>;
  createdAt: Scalars['DateTime'];
  finalSession?: Maybe<Scalars['DateTime']>;
  firstSession?: Maybe<SubscriptionBookingTicketSessionType>;
  firstSessionToBe?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  lastPayment?: Maybe<SubscriptionBookingInvoiceType>;
  nextPayment?: Maybe<Scalars['DateTime']>;
  nextSession?: Maybe<Scalars['DateTime']>;
  /** Amount (pre-discount) of booking for this child, ticket and session(s) in pence */
  originalAmount?: Maybe<Scalars['Int']>;
  questionAnswers?: Maybe<Array<Maybe<MatchedQuestionAnswerType>>>;
  schedule?: Maybe<ActivityScheduleType>;
  status: ActivityBookingTicketStatus;
  subscriptionId?: Maybe<Scalars['String']>;
  ticket?: Maybe<TicketType>;
  ticketCapacityAtBooking?: Maybe<Scalars['Int']>;
  ticketNameAtBooking?: Maybe<Scalars['String']>;
  ticketPriceAtBooking?: Maybe<Scalars['Int']>;
};

export enum SubscriptionTrialType {
  FreeTrial = 'FREE_TRIAL',
  NoTrial = 'NO_TRIAL',
  PaidTrial = 'PAID_TRIAL'
}

export type SupplierActivityResultType = {
  __typename?: 'SupplierActivityResultType';
  activities?: Maybe<Array<Maybe<SupplierMarketplaceActivityType>>>;
  filters?: Maybe<ActivityFiltersType>;
  total: Scalars['Int'];
};

export enum SupplierAdminAccessEnum {
  ActivityRegisters = 'ACTIVITY_REGISTERS'
}

export type SupplierAdminMembershipType = {
  __typename?: 'SupplierAdminMembershipType';
  /** Activity level authorisation */
  activityRegistersAccess?: Maybe<Scalars['Boolean']>;
  /**
   *
   *         Blank means supplier admin has FULL access.
   *         To restrict access to specific pages, select admin level(s) from the list
   *
   */
  adminAccess: Array<AdminAccessType>;
  /** Supplier level authorisation */
  hasRegistersAccess?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isSuperadmin?: Maybe<Scalars['Boolean']>;
  supplier: MarketplaceSupplierType;
  supplierAdmin: SupplierAdminType;
};

export type SupplierAdminType = {
  __typename?: 'SupplierAdminType';
  cognitoId?: Maybe<Scalars['UUID']>;
  cognitoLastAuthTime?: Maybe<Scalars['DateTime']>;
  cognitoStatus?: Maybe<Scalars['String']>;
  cognitoUserPoolId?: Maybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['UUID'];
  memberships?: Maybe<Array<Maybe<SupplierAdminMembershipType>>>;
  suppliers?: Maybe<Array<Maybe<MarketplaceSupplierType>>>;
};

export type SupplierAttendeeInputType = {
  activityId: Scalars['UUID'];
  supplierId: Scalars['UUID'];
  times?: Maybe<Array<Maybe<AttendeeTimeItemInputType>>>;
};

export type SupplierAttendeeListType = {
  __typename?: 'SupplierAttendeeListType';
  attendees?: Maybe<Array<Maybe<AttendeeType>>>;
  total: Scalars['Int'];
};

/** Creates and sends/schedules a booking request/invitation to input email(s) in order to book with Pebble. */
export type SupplierBookingRequestCreateMutation = {
  __typename?: 'SupplierBookingRequestCreateMutation';
  invitedEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  sent?: Maybe<Scalars['Boolean']>;
};

export type SupplierCapacityType = {
  __typename?: 'SupplierCapacityType';
  nearCapacity?: Maybe<Array<Maybe<SupplierSessionCapacityType>>>;
  noCapacity?: Maybe<Array<Maybe<SupplierSessionCapacityType>>>;
  soldOut?: Maybe<Array<Maybe<SupplierSessionCapacityType>>>;
};

export type SupplierConnectExistingStripeAccountMutation = {
  __typename?: 'SupplierConnectExistingStripeAccountMutation';
  supplier?: Maybe<MarketplaceSupplierType>;
};

/** Input fields for creating a location for a supplier's activity(ies) */
export type SupplierLocationCreateInput = {
  additionalInfo?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postCode: Scalars['String'];
  supplierId: Scalars['UUID'];
};

export type SupplierLocationCreateMutation = {
  __typename?: 'SupplierLocationCreateMutation';
  supplierLocation?: Maybe<SupplierLocationType>;
};

export type SupplierLocationDeleteMutation = {
  __typename?: 'SupplierLocationDeleteMutation';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type SupplierLocationType = {
  __typename?: 'SupplierLocationType';
  id: Scalars['UUID'];
  location?: Maybe<LocationType>;
  numberOfActivities?: Maybe<Scalars['Int']>;
  supplier?: Maybe<MarketplaceSupplierType>;
  usage: SupplierLocationUsage;
};

/** Input fields for updating a location for a supplier's activity(ies) */
export type SupplierLocationUpdateInput = {
  additionalInfo?: Maybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  id: Scalars['UUID'];
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postCode: Scalars['String'];
};

export type SupplierLocationUpdateMutation = {
  __typename?: 'SupplierLocationUpdateMutation';
  supplierLocation?: Maybe<SupplierLocationType>;
};

export enum SupplierLocationUsage {
  /** Activity */
  Activity = 'ACTIVITY'
}

export type SupplierLocationsType = {
  __typename?: 'SupplierLocationsType';
  locations?: Maybe<Array<Maybe<LocationForSupplierType>>>;
  supplier?: Maybe<MarketplaceSupplierType>;
};

/**
 * Representation of the Activity for Supplier queries,
 * contains fields that shouldn't be exposed to the Guardian or public queries
 */
export type SupplierMarketplaceActivityType = {
  __typename?: 'SupplierMarketplaceActivityType';
  activityMemberships?: Maybe<Array<Maybe<SupplierAdminMembershipType>>>;
  activityMembershipsFlat?: Maybe<Array<Maybe<Scalars['String']>>>;
  activityType: ActivityTypeEnum;
  /** Enter cloudinary image IDs as a comma separated list */
  additionalImageIds?: Maybe<Array<Scalars['String']>>;
  addons?: Maybe<Array<Maybe<AddonType>>>;
  /** Set to a value greater than Age months start. */
  ageMonthsEnd: Scalars['Int'];
  /** Set to a value greater than or equal to 0. */
  ageMonthsStart: Scalars['Int'];
  ageRange?: Maybe<Scalars['String']>;
  allowBlockBookings: Scalars['Boolean'];
  allowIndividualBookings: Scalars['Boolean'];
  blockSubtype?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<Maybe<ActivityBlockType>>>;
  /** Select between Enquire or Instant or Subscription booking */
  bookingType: ActivityBookingType;
  bookingsInformation?: Maybe<ActivityBookingInfoType>;
  categories?: Maybe<Array<Maybe<CategoryType>>>;
  cloudinaryImageId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customEmailHeader?: Maybe<Scalars['String']>;
  customEmailImageId?: Maybe<Scalars['String']>;
  customEmailMessage?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  /** Will be used for enquiries about this activity */
  email: Scalars['String'];
  enableRegisterCheckinCheckoutMode: Scalars['Boolean'];
  enquiryBookingUrl?: Maybe<Scalars['String']>;
  /** Price in pence to be displayed on activity cards for activity of booking_type enquire */
  enquiryPrice: Scalars['Int'];
  guardianToProvide?: Maybe<Scalars['String']>;
  hasBookings?: Maybe<Scalars['Boolean']>;
  hideEndTimes: Scalars['Boolean'];
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  isOnline: Scalars['Boolean'];
  location?: Maybe<LocationTypeWithResolvedCoordinates>;
  locationAdditionalInfo?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  maxDate?: Maybe<Scalars['Date']>;
  minDate?: Maybe<Scalars['Date']>;
  minTime?: Maybe<Scalars['Time']>;
  name: Scalars['String'];
  offDates?: Maybe<Array<Maybe<ActivityOffDayType>>>;
  /** The Ofsted Unique Reference Number for the Supplier Location of this Activity, required for Poncho Pay */
  ofstedUrn?: Maybe<Scalars['String']>;
  /** Private extra information field for online activities */
  onlinePrivateInfo?: Maybe<Scalars['String']>;
  /** Public extra information field for online activities */
  onlinePublicInfo?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  ponchoPayAccepted?: Maybe<Scalars['Boolean']>;
  publishedDate?: Maybe<Scalars['Date']>;
  questions?: Maybe<Array<Maybe<Question2Type>>>;
  schedules?: Maybe<Array<Maybe<ActivityScheduleType>>>;
  sessions?: Maybe<Array<Maybe<ActivitySessionType>>>;
  showEmail: Scalars['Boolean'];
  showEnquiryBookingUrl: Scalars['Boolean'];
  showPhoneNumber: Scalars['Boolean'];
  /** Unique descriptive reference for an activity based on underlying activity fields */
  slug?: Maybe<Scalars['String']>;
  /** Number of times slug field has changed due to changes to underlying activity fields */
  slugChangeCount: Scalars['Int'];
  status: ActivityStatus;
  subscriptionBillingFrequency?: Maybe<ActivitySubscriptionBillingFrequency>;
  subscriptionInfo?: Maybe<Scalars['String']>;
  /**
   *
   *         If set for a subscription activity, this is the date and time that billing and sessions start
   *         from for bookings made before this point in time. For bookings taken after it has no effect.
   *
   */
  subscriptionStart?: Maybe<Scalars['DateTime']>;
  /** Subscription trial price in pence */
  subscriptionTrialPrice?: Maybe<Scalars['Int']>;
  /** Set to a value between 0 and 3 */
  subscriptionTrialSessionCount?: Maybe<Scalars['Int']>;
  subscriptionTrialType?: Maybe<ActivitySubscriptionTrialType>;
  supplier: MarketplaceSupplierType;
  supplierLocationId?: Maybe<Scalars['UUID']>;
  supplierToProvide?: Maybe<Scalars['String']>;
  /** Term template used for activity blocks and sessions */
  term?: Maybe<TermType>;
  tickets?: Maybe<ActivityTicketType>;
  times?: Maybe<Array<Maybe<StartEndTimeType>>>;
  waitlistRequestCount?: Maybe<Scalars['Int']>;
  weekdays?: Maybe<Array<Maybe<DayOfWeek>>>;
};

/**
 * Creates a (supplier, supplier admin) membership.
 *
 * 1. If supplier admin does not exist in DB, it creates a supplier admin instance and the membership.
 *     When the supplier admin signs up with Pebble, a cognito user will be auto-assigned to supplier admin instance.
 * 2. If supplier admin exists in DB, it creates the membership with the supplier
 * 3. If supplier (supplier admin, supplier) membership exists returns the existing one.
 *
 * Params:
 *     supplier_id(str): Supplier ID
 *     supplier_admin_full_name(str): Supplier Admin's full name
 *     supplier_admin_email(str): Supplier Admin's email
 *     admin_access(enum): Admin access options to select from. If field excluded, supplier admin grants full access
 * Returns:
 *     SupplierAdminMembership(obj): The created Supplier, SupplierAdmin membership
 */
export type SupplierMembershipCreateMutation = {
  __typename?: 'SupplierMembershipCreateMutation';
  supplierAdminMembership?: Maybe<SupplierAdminMembershipType>;
};

export type SupplierMembershipDeleteMutation = {
  __typename?: 'SupplierMembershipDeleteMutation';
  deleted?: Maybe<Scalars['Boolean']>;
};

/**
 * Updates supplier membership admin access levels.
 *
 * Params:
 *     supplier_id(str): Supplier ID
 *     supplier_admin_id(str): Supplier Admin's ID
 *     admin_access(list): Admin access options to select from. If field excluded, supplier admin grants full access
 * Returns:
 *     SupplierAdminMembership(obj): The updated Supplier, SupplierAdmin membership
 */
export type SupplierMembershipUpdateMutation = {
  __typename?: 'SupplierMembershipUpdateMutation';
  supplierAdminMembership?: Maybe<SupplierAdminMembershipType>;
};

export type SupplierOnboardingTaskType = {
  __typename?: 'SupplierOnboardingTaskType';
  complete: Scalars['Boolean'];
  name: Scalars['String'];
};

export type SupplierOnboardingType = {
  __typename?: 'SupplierOnboardingType';
  complete: Scalars['Boolean'];
  tasks?: Maybe<Array<Maybe<SupplierOnboardingTaskType>>>;
};

export type SupplierPaymentAccountCreateMutation = {
  __typename?: 'SupplierPaymentAccountCreateMutation';
  supplierPaymentAccount?: Maybe<SupplierPaymentAccountType>;
};

export type SupplierPaymentAccountType = {
  __typename?: 'SupplierPaymentAccountType';
  paymentAccountId?: Maybe<Scalars['String']>;
  paymentAccountOnboardingUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AccountStatus>;
};

export enum SupplierPonchoPayStatus {
  /** Disabled */
  Disabled = 'DISABLED',
  /** Enabled */
  Enabled = 'ENABLED',
  /** Not set up */
  NotSetUp = 'NOT_SET_UP',
  /** Requested */
  Requested = 'REQUESTED'
}

/** Input for requesting supplier onboarding for Poncho Pay */
export type SupplierRequestPonchoPayInput = {
  contacts: Array<Maybe<NameEmailInput>>;
  id: Scalars['UUID'];
  ofstedLocations: Array<Maybe<OfstedLocationAndUrnInput>>;
  paymentOptions: PaymentOptionsInput;
  voucherProviders: Array<Maybe<VoucherProviderAndUrnInput>>;
};

export type SupplierRequestPonchoPayMutation = {
  __typename?: 'SupplierRequestPonchoPayMutation';
  supplier?: Maybe<MarketplaceSupplierType>;
};

export type SupplierSessionCapacityType = {
  __typename?: 'SupplierSessionCapacityType';
  activityId: Scalars['UUID'];
  bookings: Scalars['Int'];
  capacity: Scalars['Int'];
  date: Scalars['String'];
  name: Scalars['String'];
  percentBooked: Scalars['Int'];
  time: Scalars['String'];
};

export type SupplierUpcomingSessionType = {
  __typename?: 'SupplierUpcomingSessionType';
  bookingType?: Maybe<BookingTypesEnum>;
  bookings: Scalars['Int'];
  capacity: Scalars['Int'];
  date: Scalars['String'];
  id?: Maybe<Scalars['UUID']>;
  location: Scalars['String'];
  name: Scalars['String'];
  time: Scalars['String'];
};

export type SupplierUpcomingType = {
  __typename?: 'SupplierUpcomingType';
  sessionsForDate?: Maybe<Array<Maybe<SupplierUpcomingSessionType>>>;
  upcomingSessionDates?: Maybe<Array<Maybe<Scalars['Date']>>>;
};

export type SupplierUpdateMutation = {
  __typename?: 'SupplierUpdateMutation';
  supplier?: Maybe<MarketplaceSupplierType>;
};

/** Input for a term creation */
export type TermCreateInput = {
  endDate: Scalars['Date'];
  name: Scalars['String'];
  offDates?: Maybe<Array<Scalars['Date']>>;
  startDate: Scalars['Date'];
  supplier: Scalars['UUID'];
};

export type TermCreateMutation = {
  __typename?: 'TermCreateMutation';
  term?: Maybe<TermType>;
};

export enum TermDateFilterEnum {
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type TermDeleteMutation = {
  __typename?: 'TermDeleteMutation';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type TermType = {
  __typename?: 'TermType';
  /** Term template used for activity blocks and sessions */
  activitySet: Array<PublicActivityType>;
  createdAt: Scalars['DateTime'];
  endDate: Scalars['Date'];
  id: Scalars['UUID'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  offDates?: Maybe<Array<Scalars['Date']>>;
  startDate: Scalars['Date'];
  supplier: MarketplaceSupplierType;
  updatedAt: Scalars['DateTime'];
};

export enum TicketPricingPolicy {
  /** The price is not reduced based on the number of sessions left */
  BlockFullPrice = 'BLOCK_FULL_PRICE',
  /** The price is ignored and the ticket is free */
  Free = 'FREE',
  /** The price is per session */
  PerSession = 'PER_SESSION',
  /** The price recurs on a regular interval */
  Recurring = 'RECURRING'
}

export enum TicketTicketType {
  /** Block */
  Block = 'BLOCK',
  /** Individual */
  Individual = 'INDIVIDUAL',
  /** Move */
  Move = 'MOVE',
  /** Subscription */
  Subscription = 'SUBSCRIPTION'
}

export type TicketType = {
  __typename?: 'TicketType';
  allowBookingsAfterFirstSession: Scalars['Boolean'];
  availabilityEndDate?: Maybe<Scalars['Date']>;
  availabilityStartDate?: Maybe<Scalars['Date']>;
  capacity: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** `False` if availability date range is set and current time is not with the range. */
  isAvailable?: Maybe<Scalars['Boolean']>;
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  price: Scalars['Int'];
  pricingPolicy: TicketPricingPolicy;
  /** Select whether Block, Individual or Subscription ticket type */
  ticketType: TicketTicketType;
};

export type TransferWaitListMemberMutation = {
  __typename?: 'TransferWaitListMemberMutation';
  transfered?: Maybe<Scalars['Boolean']>;
};

export type UpdateActivitySessionAttendanceInputType = {
  action: AttendanceActionEnum;
  actionTime?: Maybe<Scalars['Time']>;
  activityBookingTicketSession: Scalars['UUID'];
};

export type UpdateBasketInputType = {
  activity: Scalars['UUID'];
  addons?: Maybe<Array<Maybe<AttendeeAddonInputType>>>;
  block?: Maybe<Scalars['UUID']>;
  checksum?: Maybe<Scalars['String']>;
  guest?: Maybe<GuestInputType>;
  id: Scalars['UUID'];
  isMarketingConsentGiven?: Maybe<Scalars['Boolean']>;
  promotion?: Maybe<Scalars['String']>;
  questionAnswers?: Maybe<Array<Maybe<QuestionAnswerInputType>>>;
  schedule?: Maybe<Scalars['UUID']>;
  sessions?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  supplierLinksAccepted?: Maybe<Scalars['Boolean']>;
  supplierMarketingConsentGiven?: Maybe<Scalars['Boolean']>;
  tickets?: Maybe<Array<Maybe<UpdateTicketsInputType>>>;
};

/**
 * ###
 * Requests Busy Bees NurseryRoomAvailability for specific date from NurseryCare API,
 * uses returned data to update our NurseryRoomAvailability model.
 *
 * ### Exceptions
 * Raises NurseryCareApiRateLimitException when status code of response from Nursery Care API is 429
 * (Too Many Requests). This is raised/thrown rather than handled and returned as a GraphQL Error to
 * allow the consumer to handle as a network error and implement backoff/retry functionality.
 *
 * ### GraphQL Errors
 * `UNAUTHORISED_GUARDIAN_ACTION`: When guardian not found in context, indicates a problem with authentication.
 * Also raised if guardian status is REJECTED.
 *
 * `NURSERY_NOT_MANAGED_VIA_EXTERNAL_SYSTEM`: When the room in question does not belong to a nursery from an
 * organisation that is being actively managed via integration with an external system.
 *
 * `EXTERNAL_ID_MISSING`: When room does belong to a nursery whose organization is externally managed,
 * but the room has no external_system_id value.
 *
 * `EXTERNAL_AVAILABILITY_ERROR`: When an error occurs with the NurseryCare api called.
 *
 * `EXTERNAL_RESOURCE_NOT_FOUND`: When room not found by external_system_id, refer to nursery to try and resolve.
 *
 * `ERROR_UPDATING_AVAILABILITY_WITH_EXTERNAL_DATA`: tbc
 *
 * `NO_ROOM_AVAILABILITY`: When external availability is 0 (or less), indicating that we cannot allow instant booking,
 * booking requests can still be made though (these will need approval by a nursery admin before approved/confirmed).
 */
export type UpdateFromExternalAvailabilityMutation = {
  __typename?: 'UpdateFromExternalAvailabilityMutation';
  roomAvailability?: Maybe<NurseryRoomAvailabilityMultiDateType>;
};

/**
 * ### Status update
 * Given the ID of a booking request and the desired status, tries to update its status.
 *
 * If status is changed to `REJECTED` it tries to find alternate session
 * and send SMS notification to the guardian.
 *
 * NurseryAdmin can only CONFIRM or REJECT a booking request, they cannot CANCEL one.
 *
 * ### Payments
 * This mutation creates and captures payment when booking status is changed to `CONFIRMED`.
 * When booking status is changed to `REJECTED` there is no payment processing to undertake.
 *
 * ### Room update
 * If room ID is given, the booking's room is going to be updated,
 * as well as the child's primary nursery room.
 * If the given room ID is not under the child's primary nursery,
 * then only the booking's room updated and the child's room is not.
 *
 * ### Errors
 * `UNAUTHORISED_NURSERY_ADMIN_ACTION`: When the nursery admin making the update request is not
 * the owner of the nursery in question.
 *
 * `INVALID_PAYLOAD`: Occurs when rejecting a booking, if `rejection_reason` is missing,
 * or `rejection_reason` is "Other" but `rejection_details` are missing.
 *
 * `INVALID_FIELD`: Occurs if NurseryAdmin attempts to cancel a booking (only Guardians can cancel their bookings).
 *
 * `SESSION_BOOKING_IN_PAST`: Occurs when attempting to confirm or reject a booking for a date in the past.
 *
 * `SESSION_BOOKING_ALREADY_CONFIRMED`: Occurs when attempting to confirm an already confirmed booking.
 *
 * `PAYMENT_NOT_CREATED`: When error creating a new payment intent for a paid-for booking request.
 *
 * `PAYMENT_NOT_MODIFIED`: When error updating the payment intent metadata with the booking_id.
 *
 * `PAYMENT_NOT_CAPTURED`: When there is an error capturing the payment for a paid-for booking request.
 *
 * `NURSERY_ROOM_DOES_NOT_EXIST`: Nursery room does not match a nursery room in our system.
 *
 * `NURSERY_ROOM_NOT_PROVIDED`: No room set on the booking request, or child and no roomId passed into this mutation.
 *
 * `NURSERY_DIFFERS_FROM_BOOKING`: When room_id is provided for update, but the room belongs to
 * a nursery other than the nursery of the room currently on the booking.
 *
 * `EXTERNAL_SESSION_BOOKING_ERROR`: Error creating session booking in external booking system API.
 *
 * `EXTERNAL_RESOURCE_NOT_FOUND`: Call to external booking system returned a 404, either child or room not recognised.
 *
 * `INVALID_EXTERNAL_DATA_SESSION_BOOKING_CREATE`: Error encountered during attempt to save returned data
 * from external booking system (NurseryCare).
 */
export type UpdateSessionBookingMutation = {
  __typename?: 'UpdateSessionBookingMutation';
  bookingRequest?: Maybe<SessionBookingRequestType>;
};

export type UpdateTicketsInputType = {
  attendees?: Maybe<Array<Maybe<AttendeeInputType>>>;
  id: Scalars['UUID'];
  subscriptionTrialSelected?: Maybe<Scalars['Boolean']>;
  ticket: Scalars['UUID'];
};

export type UtmParamsInputType = {
  utm_campaign?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Scalars['String']>;
  utm_source?: Maybe<Scalars['String']>;
};

export type VoucherProviderAndUrnInput = {
  provider: Scalars['String'];
  urn: Scalars['String'];
};

export type WaitListFilterType = {
  __typename?: 'WaitListFilterType';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type WaitListFiltersType = {
  __typename?: 'WaitListFiltersType';
  times?: Maybe<Array<Maybe<WaitListFilterType>>>;
  weekdays?: Maybe<Array<Maybe<WaitListFilterType>>>;
};

export type WaitListSchemaResultType = {
  __typename?: 'WaitListSchemaResultType';
  filters?: Maybe<WaitListFiltersType>;
  total?: Maybe<Scalars['Int']>;
  waitlist?: Maybe<Array<Maybe<WaitListSchemaType>>>;
};

export type WaitListSchemaType = {
  __typename?: 'WaitListSchemaType';
  activity?: Maybe<SupplierMarketplaceActivityType>;
  activityDate?: Maybe<Scalars['String']>;
  activityTime?: Maybe<Scalars['String']>;
  attendeeCount: Scalars['Int'];
  block?: Maybe<ActivityBlockType>;
  checkoutKey?: Maybe<WaitingRequestCheckoutKey>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  fullName?: Maybe<Scalars['String']>;
  guardian?: Maybe<NurseryGuardianType>;
  guest?: Maybe<GuestType>;
  id: Scalars['UUID'];
  invitedToBookAt?: Maybe<Scalars['DateTime']>;
  isDeleted: Scalars['Boolean'];
  manualActivityDate?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  schedule?: Maybe<ActivityScheduleType>;
  session?: Maybe<ActivitySessionType>;
  startDate?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['DateTime'];
  weekdays: Scalars['String'];
};

export enum WaitingRequestCheckoutKey {
  /** Block booking */
  Block = 'BLOCK',
  /** Manually added */
  ManuallyAdded = 'MANUALLY_ADDED',
  /** Subscription */
  Schedule = 'SCHEDULE',
  /** Single session */
  Session = 'SESSION',
  /** Multiple sessions */
  Sessions = 'SESSIONS',
  /** Transferred */
  Transferred = 'TRANSFERRED'
}

export type NurseryFieldsFragment = { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, isExternallyManaged: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } };

export type CancelBookingMutationVariables = Exact<{
  id: Scalars['UUID'];
  cancellationReason: BookingCancellationEnum;
  cancellationDetails?: Maybe<Scalars['String']>;
}>;


export type CancelBookingMutation = { __typename?: 'Mutations', cancelSessionBooking?: { __typename?: 'CancelSessionBookingMutation', bookingRequest?: { __typename?: 'SessionBookingRequestType', id: any, status: SessionBookingStatus, cancellationReason?: SessionBookingCancellationReason | null | undefined, cancellationDetails?: string | null | undefined, cancelledAt?: any | null | undefined } | null | undefined } | null | undefined };

export type CreateBookingPaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateBookingPaymentMethodMutation = { __typename?: 'Mutations', bookingCreatePaymentMethod?: { __typename?: 'CreatePaymentMethodMutation', success?: boolean | null | undefined, addAdditionalCard?: { __typename?: 'PaymentType', clientSecret?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'ErrorType', message?: string | null | undefined, code?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CreateChildMutationVariables = Exact<{
  child: ChildrenInput;
}>;


export type CreateChildMutation = { __typename?: 'Mutations', childCreate?: { __typename?: 'ChildCreateMutation', success?: boolean | null | undefined, child?: { __typename?: 'ChildType', id: any, fullName: string, status: ChildStatus, birthDate?: any | null | undefined, primaryNursery?: { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean } | null | undefined, primaryNurseryRoom?: { __typename?: 'NurseryRoomType', id: any, name: string } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'ErrorType', message?: string | null | undefined, code?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CreateGuardianMutationVariables = Exact<{
  fullName: Scalars['String'];
  email: Scalars['String'];
  children: Array<Maybe<ChildrenInput>> | Maybe<ChildrenInput>;
  marketingOptIn?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['UUID']>;
}>;


export type CreateGuardianMutation = { __typename?: 'Mutations', guardianCreate?: { __typename?: 'GuardianCreateMutation', success?: boolean | null | undefined, guardian?: { __typename?: 'GuardianType', id: any, fullName: string, phoneNumber: string, status: GuardianStatus, email?: string | null | undefined, anyChildrenExternallyManaged?: boolean | null | undefined, externalSystemId?: string | null | undefined, canBookChildcare?: boolean | null | undefined, canBookMarketplaceActivities?: boolean | null | undefined, children?: Array<{ __typename?: 'ChildType', isRegisteredWithNursery?: boolean | null | undefined, isExternallyManaged?: boolean | null | undefined, id: any, fullName: string, status: ChildStatus, birthDate?: any | null | undefined, primaryNursery?: { __typename?: 'NurseryType', isVisible: boolean, isExternallyManaged: boolean, id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } } | null | undefined, primaryNurseryRoom?: { __typename?: 'NurseryRoomType', id: any, name: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'ErrorType', message?: string | null | undefined, code?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type InitiatePaidSessionBookingMutationMutationVariables = Exact<{
  child: Scalars['UUID'];
  date: Scalars['Date'];
  promotion?: Maybe<Scalars['UUID']>;
  room?: Maybe<Scalars['UUID']>;
  customSessionType: Scalars['UUID'];
  bookingToCancel?: Maybe<Scalars['UUID']>;
  forceRequest?: Maybe<Scalars['Boolean']>;
}>;


export type InitiatePaidSessionBookingMutationMutation = { __typename?: 'Mutations', initiatePaidSessionBooking?: { __typename?: 'InitiatePaidSessionBookingMutation', sessionBookingStripeCheckout?: { __typename?: 'SessionBookingStripeCheckoutType', url: string, checkoutSessionId: string } | null | undefined } | null | undefined };

export type CreateSessionBookingMutationVariables = Exact<{
  child: Scalars['UUID'];
  date: Scalars['Date'];
  sessionType?: Maybe<BookingSessionTypeEnum>;
  paymentExemptionReason?: Maybe<PaymentExemptionReasonEnum>;
  promotion?: Maybe<Scalars['UUID']>;
  room?: Maybe<Scalars['UUID']>;
  additionalNotes?: Maybe<Scalars['String']>;
  customSessionType?: Maybe<Scalars['UUID']>;
  bookingToCancel?: Maybe<Scalars['UUID']>;
  forceRequest?: Maybe<Scalars['Boolean']>;
}>;


export type CreateSessionBookingMutation = { __typename?: 'Mutations', submitSessionBooking?: { __typename?: 'SubmitSessionBookingMutation', bookingRequest?: { __typename?: 'SessionBookingRequestType', id: any } | null | undefined } | null | undefined };

export type UpdateChildByGuardianMutationVariables = Exact<{
  child: ChildrenInput;
}>;


export type UpdateChildByGuardianMutation = { __typename?: 'Mutations', childUpdateByGuardian?: { __typename?: 'ChildUpdateByGuardianMutation', success?: boolean | null | undefined, child?: { __typename?: 'ChildType', id: any, fullName: string, birthDate?: any | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'ErrorType', code?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateGuardianMutationVariables = Exact<{
  guardianId: Scalars['UUID'];
  fullName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
}>;


export type UpdateGuardianMutation = { __typename?: 'Mutations', guardianUpdate?: { __typename?: 'GuardianUpdateMutation', success?: boolean | null | undefined, guardian?: { __typename?: 'GuardianType', id: any, fullName: string, phoneNumber: string, status: GuardianStatus } | null | undefined, errors?: Array<{ __typename?: 'ErrorType', message?: string | null | undefined, code?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type UpdateMarketingOptInMutationVariables = Exact<{
  guardianId: Scalars['UUID'];
  marketingOptIn?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateMarketingOptInMutation = { __typename?: 'Mutations', guardianUpdate?: { __typename?: 'GuardianUpdateMutation', success?: boolean | null | undefined, guardian?: { __typename?: 'GuardianType', id: any, marketingOptIn?: boolean | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'ErrorType', message?: string | null | undefined, code?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetAllBookingsQueryVariables = Exact<{
  bookingFilter: BookingType;
  startDate?: Maybe<Scalars['Date']>;
}>;


export type GetAllBookingsQuery = { __typename?: 'Queries', allBookingsForGuardian?: Array<{ __typename?: 'AllBookingsForGuardianType', bookingId?: any | null | undefined, sessionId?: any | null | undefined, bookingType?: string | null | undefined, subscriptionStartTime?: string | null | undefined, subscriptionEndTime?: string | null | undefined, subscriptionDayOfWeek?: string | null | undefined, status?: Status | null | undefined, date?: any | null | undefined, sessionType?: SessionType | null | undefined, showCustomSessionTimes?: boolean | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, customSessionType?: { __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType, requestOnly: boolean } | null | undefined, marketplaceActivity?: { __typename?: 'MarketplaceActivityType', id: any, name: string, bookingType: ActivityBookingType, hideEndTimes: boolean } | null | undefined, child?: { __typename?: 'ChildType', id: any, fullName: string } | null | undefined } | null | undefined> | null | undefined };

export type GetAvailabilityQueryVariables = Exact<{
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  childId: Scalars['UUID'];
}>;


export type GetAvailabilityQuery = { __typename?: 'Queries', availabilityForGuardian?: { __typename?: 'AvailabilityMultiRoomMultiDateType', earliestInstantBookingSession?: any | null | undefined, earliestBookingRequestSession?: any | null | undefined, nurseryRooms?: Array<{ __typename?: 'NurseryRoomType', id: any, name: string } | null | undefined> | null | undefined, dates?: Array<{ __typename?: 'AvailabilityMultiRoomSingleDateType', date?: any | null | undefined, amSessionsAvailable?: boolean | null | undefined, pmSessionsAvailable?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetAvailabilityForGuardianAtNonPrimaryQueryVariables = Exact<{
  nurseryId: Scalars['UUID'];
  childId: Scalars['UUID'];
  date: Scalars['Date'];
  sessionType: BookingSessionTypeEnum;
}>;


export type GetAvailabilityForGuardianAtNonPrimaryQuery = { __typename?: 'Queries', availabilityForGuardianAtNonPrimary?: { __typename?: 'AvailabilityAndPricesMultiRoomSingleDateType', nurseryRooms?: Array<{ __typename?: 'NurseryRoomWithAvailabilityAndPriceForDateType', id?: any | null | undefined, roomName?: string | null | undefined, date?: any | null | undefined, sessionType?: string | null | undefined, sessionPrice?: number | null | undefined, availableSessionCount?: number | null | undefined, nursery?: { __typename?: 'NurserySummaryType', id?: any | null | undefined, name?: string | null | undefined, organizationName?: string | null | undefined, showCustomSessionTimes?: boolean | null | undefined } | null | undefined, customSessionType?: { __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType, requestOnly: boolean } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetBookingRequestPriceQueryVariables = Exact<{
  child: Scalars['UUID'];
  date: Scalars['Date'];
  promotion?: Maybe<Scalars['UUID']>;
  sessionType?: Maybe<BookingSessionTypeEnum>;
  room?: Maybe<Scalars['UUID']>;
  customSessionType?: Maybe<Scalars['UUID']>;
  clientSecret?: Maybe<Scalars['Boolean']>;
}>;


export type GetBookingRequestPriceQuery = { __typename?: 'Queries', bookingRequestPrice?: { __typename?: 'SessionBookingPriceType', amount?: any | null | undefined, customerId?: string | null | undefined, clientSecret?: string | null | undefined } | null | undefined };

export type GetBookingsQueryVariables = Exact<{
  startDate: Scalars['Date'];
}>;


export type GetBookingsQuery = { __typename?: 'Queries', bookings?: Array<{ __typename?: 'SessionBookingRequestType', id: any, date: any, sessionType?: SessionBookingSessionType | null | undefined, status: SessionBookingStatus, cancellationReason?: SessionBookingCancellationReason | null | undefined, cancellationDetails?: string | null | undefined, rejectionReason?: SessionBookingRejectionReason | null | undefined, rejectionDetails?: string | null | undefined, isPrimary?: boolean | null | undefined, child: { __typename?: 'ChildType', id: any, fullName: string, primaryNursery?: { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, isExternallyManaged: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } } | null | undefined }, nursery: { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, isExternallyManaged: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } }, customSessionType?: { __typename?: 'CustomSessionTypeModelType', id: any } | null | undefined } | null | undefined> | null | undefined };

export type GetBookingsByIdsQueryVariables = Exact<{
  bookingIds: Array<Maybe<Scalars['UUID']>> | Maybe<Scalars['UUID']>;
}>;


export type GetBookingsByIdsQuery = { __typename?: 'Queries', bookingsByIds?: Array<{ __typename?: 'SessionBookingRequestType', id: any, date: any, sessionType?: SessionBookingSessionType | null | undefined, status: SessionBookingStatus, cancellationReason?: SessionBookingCancellationReason | null | undefined, cancellationDetails?: string | null | undefined, rejectionReason?: SessionBookingRejectionReason | null | undefined, rejectionDetails?: string | null | undefined, finalAmount?: any | null | undefined, originalAmount?: any | null | undefined, discount?: any | null | undefined, customSessionType?: { __typename?: 'CustomSessionTypeModelType', name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType, id: any } | null | undefined, child: { __typename?: 'ChildType', id: any, fullName: string, primaryNursery?: { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, isExternallyManaged: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } } | null | undefined }, nursery: { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, isExternallyManaged: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } }, payment?: { __typename?: 'PaymentType', amount?: any | null | undefined, created?: any | null | undefined, status?: PaymentStatus | null | undefined, isRefunded?: boolean | null | undefined, processor?: string | null | undefined, paymentMethod?: { __typename?: 'PaymentMethodType', card?: { __typename?: 'PaymentCardType', brand?: string | null | undefined, last4?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, promotion?: { __typename?: 'PromotionType', code?: string | null | undefined } | null | undefined, paymentMethod?: { __typename?: 'PaymentMethodType', card?: { __typename?: 'PaymentCardType', brand?: string | null | undefined, last4?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type GetCheckoutSessionMetadataQueryVariables = Exact<{
  checkoutSessionId: Scalars['String'];
}>;


export type GetCheckoutSessionMetadataQuery = { __typename?: 'Queries', getCheckoutSessionMetadata?: { __typename?: 'CheckoutSessionMetadataType', mode?: string | null | undefined, metadata?: any | null | undefined } | null | undefined };

export type GetCustomSessionTypeByIdQueryVariables = Exact<{
  child: Scalars['UUID'];
  customSessionType: Scalars['UUID'];
}>;


export type GetCustomSessionTypeByIdQuery = { __typename?: 'Queries', customSessionTypeById?: { __typename?: 'CustomSessionTypesForChildType', id?: any | null | undefined, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, availabilityType?: AvailabilityType | null | undefined, price?: number | null | undefined } | null | undefined };

export type GetCustomSessionsByChildQueryVariables = Exact<{
  nursery: Scalars['UUID'];
  child: Scalars['UUID'];
}>;


export type GetCustomSessionsByChildQuery = { __typename?: 'Queries', customSessionTypesByChild?: Array<{ __typename?: 'CustomSessionTypesForChildType', id?: any | null | undefined, name?: string | null | undefined, startTime?: any | null | undefined, endTime?: any | null | undefined, availabilityType?: AvailabilityType | null | undefined, price?: number | null | undefined, requestOnly?: boolean | null | undefined } | null | undefined> | null | undefined };

export type GetGuardianQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGuardianQuery = { __typename?: 'Queries', guardian?: { __typename?: 'GuardianType', id: any, fullName: string, phoneNumber: string, status: GuardianStatus, email?: string | null | undefined, anyChildrenExternallyManaged?: boolean | null | undefined, externalSystemId?: string | null | undefined, canBookChildcare?: boolean | null | undefined, canBookMarketplaceActivities?: boolean | null | undefined, children?: Array<{ __typename?: 'ChildType', isRegisteredWithNursery?: boolean | null | undefined, isExternallyManaged?: boolean | null | undefined, id: any, fullName: string, status: ChildStatus, birthDate?: any | null | undefined, isAdult: boolean, instantBook: boolean, primaryNursery?: { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, isExternallyManaged: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } } | null | undefined, primaryNurseryRoom?: { __typename?: 'NurseryRoomType', id: any, name: string } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMarketingPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketingPreferencesQuery = { __typename?: 'Queries', guardian?: { __typename?: 'GuardianType', id: any, marketingOptIn?: boolean | null | undefined } | null | undefined };

export type GetMarketplaceBookingsByIdsQueryVariables = Exact<{
  activityBookingIds: Array<Maybe<Scalars['UUID']>> | Maybe<Scalars['UUID']>;
}>;


export type GetMarketplaceBookingsByIdsQuery = { __typename?: 'Queries', activityBookingsByIds?: Array<{ __typename?: 'ActivityBookingSchemaType', id: any, status: ActivityBookingStatus, createdAt: any, subscriptionNextPayment?: any | null | undefined, finalAmount?: number | null | undefined, originalAmount?: number | null | undefined, discount?: number | null | undefined, activity: { __typename?: 'PublicActivityType', id: any, name: string, description: string, subscriptionOffDates?: Array<any | null | undefined> | null | undefined, subscriptionStart?: any | null | undefined, subscriptionTrialPrice?: number | null | undefined, bookingType: ActivityBookingType, isOnline: boolean, hideEndTimes: boolean, supplier: { __typename?: 'MarketplaceSupplierType', id: any, name: string }, location?: { __typename?: 'LocationTypeWithResolvedCoordinates', id: any, addressLine1: string, addressLine2?: string | null | undefined, city: string, country: LocationCountry, postCode: string } | null | undefined }, payment?: { __typename?: 'PaymentType', amount?: any | null | undefined, created?: any | null | undefined, status?: PaymentStatus | null | undefined, isRefunded?: boolean | null | undefined, paymentMethod?: { __typename?: 'PaymentMethodType', card?: { __typename?: 'PaymentCardType', brand?: string | null | undefined, last4?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, promotion?: { __typename?: 'PromotionType', code?: string | null | undefined } | null | undefined, bookedTickets?: Array<{ __typename?: 'ActivityBookingTicketType', numberOfSessions?: number | null | undefined, firstSessionDate?: any | null | undefined, lastSessionDate?: any | null | undefined, ticketNameAtBooking?: string | null | undefined, ticketPriceAtBooking?: number | null | undefined, subscriptionTrialSelected?: boolean | null | undefined, attendees: Array<{ __typename?: 'ChildType', id: any, fullName: string, externalSystemActive: boolean, status: ChildStatus }>, ticket?: { __typename?: 'TicketType', ticketType: TicketTicketType } | null | undefined, sessions?: Array<{ __typename?: 'ActivityBookingTicketSessionType', sessionStart?: any | null | undefined, sessionEnd?: any | null | undefined, id: any, sessionAddons?: Array<{ __typename?: 'ActivityBookingTicketSessionAddonType', addonId: any, name: string, price: number } | null | undefined> | null | undefined, bookingAddons?: Array<{ __typename?: 'ActivityBookingTicketAddonType', addonId: any, name: string, price: number, quantity?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetNurseriesQueryVariables = Exact<{
  organizationId?: Maybe<Scalars['UUID']>;
}>;


export type GetNurseriesQuery = { __typename?: 'Queries', nurseries?: Array<{ __typename?: 'NurseryType', id: any, name: string, isVisible: boolean, isExternallyManaged: boolean, nurseryRooms?: Array<{ __typename?: 'NurseryRoomType', id: any, name: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetNurseryByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetNurseryByIdQuery = { __typename?: 'Queries', nurseryById?: { __typename?: 'NurseryType', id: any, name: string, phoneNumber: string, addressLine1?: string | null | undefined, addressLine2?: string | null | undefined, city?: string | null | undefined, country?: string | null | undefined, postCode?: string | null | undefined, paymentsEnabled: boolean, isNonPrimaryBookingEnabled: boolean, bookingHoldThresholdDays: number, isBookingHoldEnabled: boolean, isExtracurricularActivityEnabled?: boolean | null | undefined, allowOnlyFullDaySessions: boolean, isCustomSessionBookingsEnabled: boolean, showCustomSessionTimes: boolean, isExternallyManaged: boolean, sessionTypes?: Array<{ __typename?: 'CustomSessionTypeModelType', id: any, name: string, startTime: any, endTime: any, availabilityType: CustomSessionTypeAvailabilityType } | null | undefined> | null | undefined, organization: { __typename?: 'NurseryOrganizationType', id: any, name: string } } | null | undefined };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Queries', nurseryOrganizationsForGuardians?: Array<{ __typename?: 'NurseryOrganizationType', id: any, name: string, isVisible: boolean, isManagedByExternalSystem: boolean } | null | undefined> | null | undefined };

export type GetPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentMethodsQuery = { __typename?: 'Queries', guardian?: { __typename?: 'GuardianType', id: any, paymentMethods?: Array<{ __typename?: 'PaymentMethodType', id?: string | null | undefined, type?: string | null | undefined, created?: any | null | undefined, isDefault?: boolean | null | undefined, card?: { __typename?: 'PaymentCardType', brand?: string | null | undefined, last4?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetPriceListQueryVariables = Exact<{
  childId: Scalars['UUID'];
}>;


export type GetPriceListQuery = { __typename?: 'Queries', childPriceListById?: { __typename?: 'ChildType', id: any, primaryNurseryPriceList?: Array<{ __typename?: 'PriceListByChildType', amPrice?: number | null | undefined, endDate?: string | null | undefined, fullDayPrice?: number | null | undefined, id: any, pmPrice?: number | null | undefined, startDate?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetPromotionQueryVariables = Exact<{
  code: Scalars['String'];
  bookingType: BookingTypeEnum;
  bookingDate: Scalars['Date'];
  amount: Scalars['Int'];
  nursery?: Maybe<Scalars['UUID']>;
  supplier?: Maybe<Scalars['UUID']>;
}>;


export type GetPromotionQuery = { __typename?: 'Queries', promotionForGuardians?: { __typename?: 'BookingPromotionType', id?: any | null | undefined, finalAmount?: number | null | undefined, discount?: number | null | undefined, originalAmount?: number | null | undefined } | null | undefined };
